export const cfcVsBfcPlayerList = [
  {
    id: '63cc161b6bc8d3ddb98f736c',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '100348',
    teamId: '453',
    name: 'Vincy Barretto',
    shortName: 'Vincy Barretto',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f736d',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '100362',
    teamId: '451',
    name: 'Bruno Silva Almeida',
    shortName: 'Bruno Silva Almeida',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f736e',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '100377',
    teamId: '453',
    name: 'Alexander Romario Jesuraj',
    shortName: 'Alexander Romario Jesuraj',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f736f',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '100411',
    teamId: '453',
    name: 'Mohamed Liyaakath Ahmed',
    shortName: 'Mohamed Liyaakath Ahmed',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7370',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '103385',
    teamId: '453',
    name: 'Devansh Dabas',
    shortName: 'Devansh Dabas',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7373',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '103386',
    teamId: '453',
    name: 'Subhadip Majhi',
    shortName: 'Subhadip Majhi',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7374',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '11400',
    teamId: '453',
    name: 'Fallou Diagne',
    shortName: 'Fallou Diagne',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7375',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '135686',
    teamId: '453',
    name: 'Gurmukh Singh',
    shortName: 'Gurmukh Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7376',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '17197',
    teamId: '453',
    name: 'Julius Duker',
    shortName: 'Julius Duker',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7377',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '197055',
    teamId: '453',
    name: 'Chris Anthoy White',
    shortName: 'Chris Anthoy White',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7378',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202611',
    teamId: '451',
    name: 'Faisal Ali',
    shortName: 'Faisal Ali',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7379',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202622',
    teamId: '453',
    name: 'Monotosh Chakladar',
    shortName: 'Monotosh Chakladar',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7383',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202623',
    teamId: '453',
    name: 'Gulab Rauth',
    shortName: 'Gulab Rauth',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7384',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202624',
    teamId: '453',
    name: 'Sajal Bag',
    shortName: 'Sajal Bag',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7385',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202625',
    teamId: '453',
    name: 'Senthamil Shanbagam',
    shortName: 'Senthamil Shanbagam',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7386',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202626',
    teamId: '453',
    name: 'Rahul Manjula',
    shortName: 'Rahul Manjula',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7387',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202637',
    teamId: '453',
    name: 'Aakash Sangwan',
    shortName: 'Aakash Sangwan',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7388',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '202639',
    teamId: '453',
    name: 'Abdenasser El Khayati',
    shortName: 'Abdenasser El Khayati',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7389',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '205721',
    teamId: '453',
    name: 'Yumkhaibam Singh',
    shortName: 'Yumkhaibam Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f738a',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '22155',
    teamId: '451',
    name: 'Javi Hernandez',
    shortName: 'Javi Hernandez',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f738b',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '25190',
    teamId: '451',
    name: 'Pablo Perez Rodriguez',
    shortName: 'Pablo Perez Rodriguez',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f738c',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '29488',
    teamId: '453',
    name: 'Salam Singh',
    shortName: 'Salam Singh',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f738d',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '29800',
    teamId: '451',
    name: 'Edmund Lalrindika',
    shortName: 'Edmund Lalrindika',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f738e',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '3093',
    teamId: '451',
    name: 'Alan Costa',
    shortName: 'Alan Costa',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7396',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '31049',
    teamId: '451',
    name: 'Parag Satish Shrivas',
    shortName: 'Parag Satish Shrivas',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7397',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '40384',
    teamId: '453',
    name: 'Petar Sliskovic',
    shortName: 'Petar Sliskovic',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7398',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '44379',
    teamId: '453',
    name: 'Kwame Karikari',
    shortName: 'Kwame Karikari',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f7399',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47144',
    teamId: '451',
    name: 'Suresh Singh Wangjam',
    shortName: 'Suresh Singh Wangjam',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f739a',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47147',
    teamId: '453',
    name: 'Jobby Justin',
    shortName: 'Jobby Justin',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f739b',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47148',
    teamId: '451',
    name: 'Lara Sharma',
    shortName: 'Lara Sharma',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f739c',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47156',
    teamId: '453',
    name: 'Sourav Das',
    shortName: 'Sourav Das',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f739d',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47166',
    teamId: '451',
    name: 'Amrit Gope',
    shortName: 'Amrit Gope',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f739e',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47173',
    teamId: '453',
    name: 'Ninthoi Meetei',
    shortName: 'Ninthoi Meetei',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f739f',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47186',
    teamId: '453',
    name: 'Lovepreet Singh',
    shortName: 'Lovepreet Singh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a0',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '47193',
    teamId: '453',
    name: 'Edwin Vanspaul',
    shortName: 'Edwin Vanspaul',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a1',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '56899',
    teamId: '451',
    name: 'Prince Ibara',
    shortName: 'Prince Ibara',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a2',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '6018',
    teamId: '451',
    name: 'Roy Krishna',
    shortName: 'Roy Krishna',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a3',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64021',
    teamId: '451',
    name: 'Namgyal Bhutia',
    shortName: 'Namgyal Bhutia',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a4',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64022',
    teamId: '453',
    name: 'Ajith Kumar',
    shortName: 'Ajith Kumar',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a5',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64024',
    teamId: '451',
    name: 'Wungngayam Muirang',
    shortName: 'Wungngayam Muirang',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a6',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64025',
    teamId: '451',
    name: 'Naorem Roshan Singh',
    shortName: 'Naorem Roshan Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a7',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64026',
    teamId: '451',
    name: 'Thoi Singh',
    shortName: 'Thoi Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a8',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64028',
    teamId: '451',
    name: 'Biswa Darjee',
    shortName: 'Biswa Darjee',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73a9',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64029',
    teamId: '451',
    name: 'Amay Morajkar',
    shortName: 'Amay Morajkar',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73aa',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64041',
    teamId: '453',
    name: 'Samik Mitra',
    shortName: 'Samik Mitra',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73ab',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64043',
    teamId: '453',
    name: 'Aqib Nawab',
    shortName: 'Aqib Nawab',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73ac',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '64044',
    teamId: '453',
    name: 'Balaji Ganesan',
    shortName: 'Balaji Ganesan',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73ad',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '65125',
    teamId: '453',
    name: 'Jockson Dhas',
    shortName: 'Jockson Dhas',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73ae',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '65129',
    teamId: '453',
    name: 'Syed Suhail Pasha',
    shortName: 'Syed Suhail Pasha',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73af',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '65131',
    teamId: '453',
    name: 'Lijo Francis',
    shortName: 'Lijo Francis',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b0',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '65368',
    teamId: '451',
    name: 'Harmanpreet Singh',
    shortName: 'Harmanpreet Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b1',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '67938',
    teamId: '451',
    name: 'Aleksandar Jovanovic',
    shortName: 'Aleksandar Jovanovic',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b2',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '76093',
    teamId: '451',
    name: 'Damait Lyngdoh',
    shortName: 'Damait Lyngdoh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b3',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '76094',
    teamId: '451',
    name: 'Sivasakthi Narayanan',
    shortName: 'Sivasakthi Narayanan',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b4',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '80010',
    teamId: '453',
    name: 'Vafa Hakhamaneshi',
    shortName: 'Vafa Hakhamaneshi',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b5',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8640',
    teamId: '451',
    name: 'Sunil Chhetri',
    shortName: 'Sunil Chhetri',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b6',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8641',
    teamId: '451',
    name: 'Gurpreet Singh Sandhu',
    shortName: 'Gurpreet Singh Sandhu',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b7',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8649',
    teamId: '451',
    name: 'Udanta Singh',
    shortName: 'Udanta Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b8',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8670',
    teamId: '451',
    name: 'Leon Agustine Asokan',
    shortName: 'Leon Agustine Asokan',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73b9',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8684',
    teamId: '451',
    name: 'Jayesh Rane',
    shortName: 'Jayesh Rane',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73ba',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8687',
    teamId: '451',
    name: 'Prabir Das',
    shortName: 'Prabir Das',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73bb',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8694',
    teamId: '453',
    name: 'Debjit Majumder',
    shortName: 'Debjit Majumder',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73bc',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8724',
    teamId: '453',
    name: 'Anirudh Thapa',
    shortName: 'Anirudh Thapa',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73bd',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8730',
    teamId: '453',
    name: 'Rahim Ali',
    shortName: 'Rahim Ali',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73be',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8745',
    teamId: '453',
    name: 'Mohammad Sajid Dhot',
    shortName: 'Mohammad Sajid Dhot',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73bf',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8766',
    teamId: '453',
    name: 'Narayan Das',
    shortName: 'Narayan Das',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73c0',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8806',
    teamId: '451',
    name: 'Rohit Kumar',
    shortName: 'Rohit Kumar',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73c1',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8822',
    teamId: '451',
    name: 'Sandesh Jhingan',
    shortName: 'Sandesh Jhingan',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73cb',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8832',
    teamId: '453',
    name: 'K Prasanth',
    shortName: 'K Prasanth',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73cc',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '8859',
    teamId: '453',
    name: 'Mohammed Rafique',
    shortName: 'Mohammed Rafique',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73cd',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '97178',
    teamId: '451',
    name: 'Danish Farooq',
    shortName: 'Danish Farooq',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cc161b6bc8d3ddb98f73ce',
    matchId: '63cc159c6bc8d3ddb98f5cf6',
    playerId: '97180',
    teamId: '451',
    name: 'Sharon Padattil',
    shortName: 'Sharon Padattil',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4.5,
    totalPoints: 0
  }
];
export const odiVsBfcPlayerList = [
  {
    id: '6352d39ae1e4df00fa126adb',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '100351',
    teamId: '451',
    name: 'Hira Mondal',
    shortName: 'Hira Mondal',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '24',
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126adc',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '100362',
    teamId: '451',
    name: 'Bruno Silva Almeida',
    shortName: 'Bruno Silva Almeida',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '6',
    playingRole: 'Midfielder',
    points: {
      pid: '100362',
      pname: 'Bruno Silva Almeida',
      points: 20,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 5,
      tacklewon: 0,
      interceptionwon: 8,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.446Z'
    },
    stats: {
      pid: 100362,
      pname: 'Bruno Silva Almeida',
      teamtype: 'away',
      minutesplayed: 83,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 1,
      interceptionwon: 2,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 81.08,
      accuratepass: 30,
      totalpass: 37,
      longballsacc: 3,
      totallongballs: 4,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 1,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 8,
      duelswon: 8,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.058Z'
    },
    rating: 8.5,
    totalPoints: 20,
    lastPoints: 20
  },
  {
    id: '6352d39ae1e4df00fa126add',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '100416',
    teamId: '454',
    name: 'Sebastian Thangmuansang',
    shortName: 'Sebastian Thangmuansang',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ade',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '100417',
    teamId: '454',
    name: 'Deven Sawhney',
    shortName: 'Deven Sawhney',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126adf',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '103383',
    teamId: '454',
    name: 'Akshunna Tyagi',
    shortName: 'Akshunna Tyagi',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '12',
    playingRole: 'Forward',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ae0',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '12049',
    teamId: '454',
    name: 'Victor Rodriguez',
    shortName: 'Victor Rodriguez',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '32',
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ae1',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '202611',
    teamId: '451',
    name: 'Faisal Ali',
    shortName: 'Faisal Ali',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ae2',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '202627',
    teamId: '454',
    name: 'Rishabh Dobriyal',
    shortName: 'Rishabh Dobriyal',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ae3',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '202985',
    teamId: '454',
    name: 'Carlos Javier',
    shortName: 'Carlos Javier',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '5',
    playingRole: 'Defender',
    points: {
      pid: '202985',
      pname: 'Carlos Javier',
      points: 42,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 0,
      passes: 4,
      tacklewon: 4,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 20,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.447Z'
    },
    stats: {
      pid: 202985,
      pname: 'Carlos Javier',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 9,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 24,
      totalpass: 32,
      longballsacc: 0,
      totallongballs: 4,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.058Z'
    },
    rating: 7,
    totalPoints: 42,
    lastPoints: 42
  },
  {
    id: '6352d39ae1e4df00fa126ae4',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '22155',
    teamId: '451',
    name: 'Javi Hernandez',
    shortName: 'Javi Hernandez',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ae5',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '25713',
    teamId: '454',
    name: 'Pedro Martin',
    shortName: 'Pedro Martin',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '7',
    playingRole: 'Forward',
    points: {
      pid: '25713',
      pname: 'Pedro Martin',
      points: 15,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 6,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.431Z'
    },
    stats: {
      pid: 25713,
      pname: 'Pedro Martin',
      teamtype: 'home',
      minutesplayed: 36,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 81.82,
      accuratepass: 9,
      totalpass: 11,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 2,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.051Z'
    },
    rating: 7,
    totalPoints: 15,
    lastPoints: 15
  },
  {
    id: '6352d39ae1e4df00fa126ae6',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '28202',
    teamId: '454',
    name: 'Raynier Fernandes',
    shortName: 'Raynier Fernandes',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '10',
    playingRole: 'Midfielder',
    points: {
      pid: '28202',
      pname: 'Raynier Fernandes',
      points: 26,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 6,
      passes: 6,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.432Z'
    },
    stats: {
      pid: 28202,
      pname: 'Raynier Fernandes',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 1,
      shotsblocked: 1,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 81.82,
      accuratepass: 27,
      totalpass: 33,
      longballsacc: 2,
      totallongballs: 4,
      totalcross: 2,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.052Z'
    },
    rating: 8.5,
    totalPoints: 26,
    lastPoints: 26
  },
  {
    id: '6352d39ae1e4df00fa126ae7',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '28210',
    teamId: '454',
    name: 'Karan Amin',
    shortName: 'Karan Amin',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ae8',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '28267',
    teamId: '454',
    name: 'Michael Soosairaj',
    shortName: 'Michael Soosairaj',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126ae9',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '29800',
    teamId: '451',
    name: 'Edmund Lalrindika',
    shortName: 'Edmund Lalrindika',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126aea',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '29963',
    teamId: '454',
    name: 'Hendry Antonay',
    shortName: 'Hendry Antonay',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126aeb',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '3093',
    teamId: '451',
    name: 'Alan Costa',
    shortName: 'Alan Costa',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '5',
    playingRole: 'Defender',
    points: {
      pid: '3093',
      pname: 'Alan Costa',
      points: 5,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 0,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.412Z'
    },
    stats: {
      pid: 3093,
      pname: 'Alan Costa',
      teamtype: 'away',
      minutesplayed: 12,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 50,
      accuratepass: 1,
      totalpass: 2,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.028Z'
    },
    rating: 9,
    totalPoints: 5,
    lastPoints: 5
  },
  {
    id: '6352d39ae1e4df00fa126aec',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '31049',
    teamId: '451',
    name: 'Parag Satish Shrivas',
    shortName: 'Parag Satish Shrivas',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '2',
    playingRole: 'Defender',
    points: {
      pid: '31049',
      pname: 'Parag Satish Shrivas',
      points: 18,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 4,
      tacklewon: 8,
      interceptionwon: 8,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: -4,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.433Z'
    },
    stats: {
      pid: 31049,
      pname: 'Parag Satish Shrivas',
      teamtype: 'away',
      minutesplayed: 45,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 2,
      tacklecommitted: 3,
      tacklesuccess: 3,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 51.72,
      accuratepass: 15,
      totalpass: 29,
      longballsacc: 2,
      totallongballs: 7,
      totalcross: 3,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 7,
      duelswon: 7,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 1,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.052Z'
    },
    rating: 7.5,
    totalPoints: 18,
    lastPoints: 18
  },
  {
    id: '6352d39ae1e4df00fa126aed',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '40969',
    teamId: '454',
    name: 'Saul Crespo Prieto',
    shortName: 'Saul Crespo Prieto',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '21',
    playingRole: 'Midfielder',
    points: {
      pid: '40969',
      pname: 'Saul Crespo Prieto',
      points: 36,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 9,
      passes: 7,
      tacklewon: 12,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.435Z'
    },
    stats: {
      pid: 40969,
      pname: 'Saul Crespo Prieto',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 8,
      outfielderblock: 2,
      interceptionwon: 0,
      tacklecommitted: 4,
      tacklesuccess: 4,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 67.31,
      accuratepass: 35,
      totalpass: 52,
      longballsacc: 5,
      totallongballs: 12,
      totalcross: 1,
      crossesacc: 1,
      bigchancecreated: 1,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 10,
      duelswon: 10,
      wasfouled: 1,
      fouls: 2,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 3,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.053Z'
    },
    rating: 8,
    totalPoints: 36,
    lastPoints: 36
  },
  {
    id: '6352d39ae1e4df00fa126aee',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '47144',
    teamId: '451',
    name: 'Suresh Singh Wangjam',
    shortName: 'Suresh Singh Wangjam',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '8',
    playingRole: 'Midfielder',
    points: {
      pid: '47144',
      pname: 'Suresh Singh Wangjam',
      points: 17,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 4,
      tacklewon: 4,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.436Z'
    },
    stats: {
      pid: 47144,
      pname: 'Suresh Singh Wangjam',
      teamtype: 'away',
      minutesplayed: 31,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 88.89,
      accuratepass: 24,
      totalpass: 27,
      longballsacc: 1,
      totallongballs: 2,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.053Z'
    },
    rating: 6.5,
    totalPoints: 17,
    lastPoints: 17
  },
  {
    id: '6352d39ae1e4df00fa126aef',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '47148',
    teamId: '451',
    name: 'Lara Sharma',
    shortName: 'Lara Sharma',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: true,
    shirtnumber: '30',
    playingRole: 'Goalkeeper',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126af0',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '47164',
    teamId: '454',
    name: 'Niraj Kumar',
    shortName: 'Niraj Kumar',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126af1',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '47165',
    teamId: '454',
    name: 'Narender Gahlot',
    shortName: 'Narender Gahlot',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '3',
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126af2',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '47166',
    teamId: '451',
    name: 'Amrit Gope',
    shortName: 'Amrit Gope',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126af3',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '47257',
    teamId: '454',
    name: 'Lalhrezuala Sailung',
    shortName: 'Lalhrezuala Sailung',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126af4',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '47258',
    teamId: '454',
    name: 'Van Lal Remtluanga Chhangte',
    shortName: 'Van Lal Remtluanga Chhangte',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126af5',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '56679',
    teamId: '454',
    name: 'Diego Mauricio',
    shortName: 'Diego Mauricio',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '9',
    playingRole: 'Forward',
    points: {
      pid: '56679',
      pname: 'Diego Mauricio',
      points: 16,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 6,
      passes: 2,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.437Z'
    },
    stats: {
      pid: 56679,
      pname: 'Diego Mauricio',
      teamtype: 'home',
      minutesplayed: 54,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 1,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 1,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 66.67,
      accuratepass: 12,
      totalpass: 18,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 1,
      fouls: 2,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.054Z'
    },
    rating: 8.5,
    totalPoints: 16,
    lastPoints: 16
  },
  {
    id: '6352d39ae1e4df00fa126af6',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '56899',
    teamId: '451',
    name: 'Prince Ibara',
    shortName: 'Prince Ibara',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126af7',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '6018',
    teamId: '451',
    name: 'Roy Krishna',
    shortName: 'Roy Krishna',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '22',
    playingRole: 'Forward',
    points: {
      pid: '6018',
      pname: 'Roy Krishna',
      points: 16,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 0,
      passes: 2,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.413Z'
    },
    stats: {
      pid: 6018,
      pname: 'Roy Krishna',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 2,
      shotsblocked: 1,
      dribbleattempts: 3,
      dribblesuccess: 1,
      bigchancemissed: 1,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 84.62,
      accuratepass: 11,
      totalpass: 13,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 7,
      duelswon: 7,
      wasfouled: 2,
      fouls: 2,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.030Z'
    },
    rating: 9,
    totalPoints: 16,
    lastPoints: 16
  },
  {
    id: '6352d39ae1e4df00fa126af8',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '6039',
    teamId: '454',
    name: 'Osama Malik',
    shortName: 'Osama Malik',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '6',
    playingRole: 'Midfielder',
    points: {
      pid: '6039',
      pname: 'Osama Malik',
      points: 9,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 5,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.414Z'
    },
    stats: {
      pid: 6039,
      pname: 'Osama Malik',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 2,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 4,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 78.79,
      accuratepass: 26,
      totalpass: 33,
      longballsacc: 4,
      totallongballs: 6,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.032Z'
    },
    rating: 7.5,
    totalPoints: 9,
    lastPoints: 9
  },
  {
    id: '6352d39ae1e4df00fa126af9',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64021',
    teamId: '451',
    name: 'Namgyal Bhutia',
    shortName: 'Namgyal Bhutia',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '25',
    playingRole: 'Defender',
    points: {
      pid: '64021',
      pname: 'Namgyal Bhutia',
      points: 20,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 6,
      passes: 8,
      tacklewon: 0,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.438Z'
    },
    stats: {
      pid: 64021,
      pname: 'Namgyal Bhutia',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 81.25,
      accuratepass: 39,
      totalpass: 48,
      longballsacc: 7,
      totallongballs: 9,
      totalcross: 7,
      crossesacc: 5,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.054Z'
    },
    rating: 5.5,
    totalPoints: 20,
    lastPoints: 20
  },
  {
    id: '6352d39ae1e4df00fa126afa',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64024',
    teamId: '451',
    name: 'Wungngayam Muirang',
    shortName: 'Wungngayam Muirang',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '15',
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126afb',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64025',
    teamId: '451',
    name: 'Naorem Roshan Singh',
    shortName: 'Naorem Roshan Singh',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '32',
    playingRole: 'Defender',
    points: {
      pid: '64025',
      pname: 'Naorem Roshan Singh',
      points: 13,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 3,
      tacklewon: 8,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.440Z'
    },
    stats: {
      pid: 64025,
      pname: 'Naorem Roshan Singh',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 1,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 4,
      tacklesuccess: 4,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 56.67,
      accuratepass: 17,
      totalpass: 30,
      longballsacc: 1,
      totallongballs: 6,
      totalcross: 4,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 6,
      duelswon: 6,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.055Z'
    },
    rating: 8.5,
    totalPoints: 13,
    lastPoints: 13
  },
  {
    id: '6352d39ae1e4df00fa126afc',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64026',
    teamId: '451',
    name: 'Thoi Singh',
    shortName: 'Thoi Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '36',
    playingRole: 'Midfielder',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126afd',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64028',
    teamId: '451',
    name: 'Biswa Darjee',
    shortName: 'Biswa Darjee',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126afe',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64029',
    teamId: '451',
    name: 'Amay Morajkar',
    shortName: 'Amay Morajkar',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126aff',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64050',
    teamId: '454',
    name: 'Paul Ramfangzauva',
    shortName: 'Paul Ramfangzauva',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '8',
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b00',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64053',
    teamId: '454',
    name: 'Thoiba Singh Moirangthem',
    shortName: 'Thoiba Singh Moirangthem',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '24',
    playingRole: 'Defender',
    points: {
      pid: '64053',
      pname: 'Thoiba Singh Moirangthem',
      points: 40,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 5,
      tacklewon: 4,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 20,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.441Z'
    },
    stats: {
      pid: 64053,
      pname: 'Thoiba Singh Moirangthem',
      teamtype: 'home',
      minutesplayed: 81,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 1,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 24,
      totalpass: 32,
      longballsacc: 2,
      totallongballs: 3,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.056Z'
    },
    rating: 8.5,
    totalPoints: 40,
    lastPoints: 40
  },
  {
    id: '6352d39ae1e4df00fa126b01',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64055',
    teamId: '454',
    name: 'Isak Vanlalruatfela',
    shortName: 'Isak Vanlalruatfela',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '19',
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b02',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '64059',
    teamId: '454',
    name: 'Antonio D Silva',
    shortName: 'Antonio D Silva',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b03',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '65296',
    teamId: '454',
    name: 'Denechandra Meitei',
    shortName: 'Denechandra Meitei',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '30',
    playingRole: 'Defender',
    points: {
      pid: '65296',
      pname: 'Denechandra Meitei',
      points: 3,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.442Z'
    },
    stats: {
      pid: 65296,
      pname: 'Denechandra Meitei',
      teamtype: 'home',
      minutesplayed: 32,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 80,
      accuratepass: 8,
      totalpass: 10,
      longballsacc: 3,
      totallongballs: 5,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.056Z'
    },
    rating: 6.5,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '6352d39ae1e4df00fa126b04',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '65343',
    teamId: '454',
    name: 'Nikhil Prabhu',
    shortName: 'Nikhil Prabhu',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b05',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '65368',
    teamId: '451',
    name: 'Harmanpreet Singh',
    shortName: 'Harmanpreet Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b06',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '67938',
    teamId: '451',
    name: 'Aleksandar Jovanovic',
    shortName: 'Aleksandar Jovanovic',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '4',
    playingRole: 'Defender',
    points: {
      pid: '67938',
      pname: 'Aleksandar Jovanovic',
      points: 15,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 6,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.444Z'
    },
    stats: {
      pid: 67938,
      pname: 'Aleksandar Jovanovic',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 3,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 76.09,
      accuratepass: 35,
      totalpass: 46,
      longballsacc: 7,
      totallongballs: 14,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.057Z'
    },
    rating: 7,
    totalPoints: 15,
    lastPoints: 15
  },
  {
    id: '6352d39ae1e4df00fa126b07',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '76093',
    teamId: '451',
    name: 'Damait Lyngdoh',
    shortName: 'Damait Lyngdoh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b08',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '76094',
    teamId: '451',
    name: 'Sivasakthi Narayanan',
    shortName: 'Sivasakthi Narayanan',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '39',
    playingRole: 'Midfielder',
    points: {
      pid: '76094',
      pname: 'Sivasakthi Narayanan',
      points: 4,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 0,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.445Z'
    },
    stats: {
      pid: 76094,
      pname: 'Sivasakthi Narayanan',
      teamtype: 'away',
      minutesplayed: 45,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 2,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 3,
      totalpass: 4,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.057Z'
    },
    rating: 6.5,
    totalPoints: 4,
    lastPoints: 4
  },
  {
    id: '6352d39ae1e4df00fa126b09',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8640',
    teamId: '451',
    name: 'Sunil Chhetri',
    shortName: 'Sunil Chhetri',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '11',
    playingRole: 'Forward',
    points: {
      pid: '8640',
      pname: 'Sunil Chhetri',
      points: 16,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 4,
      tacklewon: 8,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.416Z'
    },
    stats: {
      pid: 8640,
      pname: 'Sunil Chhetri',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 3,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 73.08,
      accuratepass: 19,
      totalpass: 26,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 3,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 10,
      duelswon: 10,
      wasfouled: 3,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.036Z'
    },
    rating: 9,
    totalPoints: 16,
    lastPoints: 16
  },
  {
    id: '6352d39ae1e4df00fa126b0a',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8641',
    teamId: '451',
    name: 'Gurpreet Singh Sandhu',
    shortName: 'Gurpreet Singh Sandhu',
    playingEleven: true,
    role: 'Goalkeeper',
    played: true,
    substitute: false,
    shirtnumber: '1',
    playingRole: 'Goalkeeper',
    points: {
      pid: '8641',
      pname: 'Gurpreet Singh Sandhu',
      points: 33,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 30,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.417Z'
    },
    stats: {
      pid: 8641,
      pname: 'Gurpreet Singh Sandhu',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 44.83,
      accuratepass: 13,
      totalpass: 29,
      longballsacc: 6,
      totallongballs: 22,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 1,
      saves: 5,
      savesfrominsidebox: 4,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.038Z'
    },
    rating: 8.5,
    totalPoints: 33,
    lastPoints: 33
  },
  {
    id: '6352d39ae1e4df00fa126b0b',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8648',
    teamId: '454',
    name: 'Lalthuammawia Ralte',
    shortName: 'Lalthuammawia Ralte',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: true,
    shirtnumber: '28',
    playingRole: 'Goalkeeper',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b0c',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8649',
    teamId: '451',
    name: 'Udanta Singh',
    shortName: 'Udanta Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b0d',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8670',
    teamId: '451',
    name: 'Leon Agustine Asokan',
    shortName: 'Leon Agustine Asokan',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '31',
    playingRole: 'Midfielder',
    points: {
      pid: '8670',
      pname: 'Leon Agustine Asokan',
      points: 10,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 2,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.418Z'
    },
    stats: {
      pid: 8670,
      pname: 'Leon Agustine Asokan',
      teamtype: 'away',
      minutesplayed: 83,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 6,
      dribblesuccess: 2,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 48,
      accuratepass: 12,
      totalpass: 25,
      longballsacc: 0,
      totallongballs: 6,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 6,
      duelswon: 6,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.041Z'
    },
    rating: 6,
    totalPoints: 10,
    lastPoints: 10
  },
  {
    id: '6352d39ae1e4df00fa126b0e',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8684',
    teamId: '451',
    name: 'Jayesh Rane',
    shortName: 'Jayesh Rane',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '7',
    playingRole: 'Midfielder',
    points: {
      pid: '8684',
      pname: 'Jayesh Rane',
      points: 16,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 4,
      tacklewon: 0,
      interceptionwon: 8,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.419Z'
    },
    stats: {
      pid: 8684,
      pname: 'Jayesh Rane',
      teamtype: 'away',
      minutesplayed: 59,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 2,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 2,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 70.83,
      accuratepass: 17,
      totalpass: 24,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 0,
      fouls: 2,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.042Z'
    },
    rating: 7.5,
    totalPoints: 16,
    lastPoints: 16
  },
  {
    id: '6352d39ae1e4df00fa126b11',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8687',
    teamId: '451',
    name: 'Prabir Das',
    shortName: 'Prabir Das',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b12',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8722',
    teamId: '454',
    name: 'Isaac Vanmalsawma',
    shortName: 'Isaac Vanmalsawma',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '48',
    playingRole: 'Midfielder',
    points: {
      pid: '8722',
      pname: 'Isaac Vanmalsawma',
      points: 2,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 0,
      tacklewon: 0,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: -4,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.421Z'
    },
    stats: {
      pid: 8722,
      pname: 'Isaac Vanmalsawma',
      teamtype: 'home',
      minutesplayed: 9,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 3,
      totalpass: 4,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 1,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.043Z'
    },
    rating: 8,
    totalPoints: 2,
    lastPoints: 2
  },
  {
    id: '6352d39ae1e4df00fa126b13',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8748',
    teamId: '454',
    name: 'Nandhakumar Sekar',
    shortName: 'Nandhakumar Sekar',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '11',
    playingRole: 'Midfielder',
    points: {
      pid: '8748',
      pname: 'Nandhakumar Sekar',
      points: 75,
      starting11: 4,
      substitute: 0,
      goal: 50,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 3,
      passes: 4,
      tacklewon: 4,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.422Z'
    },
    stats: {
      pid: 8748,
      pname: 'Nandhakumar Sekar',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 1,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 2,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 64.52,
      accuratepass: 20,
      totalpass: 31,
      longballsacc: 0,
      totallongballs: 3,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.044Z'
    },
    rating: 7.5,
    totalPoints: 75,
    lastPoints: 75
  },
  {
    id: '6352d39ae1e4df00fa126b14',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8752',
    teamId: '454',
    name: 'Shubham Sarangi',
    shortName: 'Shubham Sarangi',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '15',
    playingRole: 'Defender',
    points: {
      pid: '8752',
      pname: 'Shubham Sarangi',
      points: 41,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 4,
      interceptionwon: 12,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 20,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.423Z'
    },
    stats: {
      pid: 8752,
      pname: 'Shubham Sarangi',
      teamtype: 'home',
      minutesplayed: 58,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 4,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 62.5,
      accuratepass: 5,
      totalpass: 8,
      longballsacc: 0,
      totallongballs: 1,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 3,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.045Z'
    },
    rating: 6,
    totalPoints: 41,
    lastPoints: 41
  },
  {
    id: '6352d39ae1e4df00fa126b15',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8806',
    teamId: '451',
    name: 'Rohit Kumar',
    shortName: 'Rohit Kumar',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '18',
    playingRole: 'Midfielder',
    points: {
      pid: '8806',
      pname: 'Rohit Kumar',
      points: 7,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.424Z'
    },
    stats: {
      pid: 8806,
      pname: 'Rohit Kumar',
      teamtype: 'away',
      minutesplayed: 12,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 90,
      accuratepass: 9,
      totalpass: 10,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.046Z'
    },
    rating: 5,
    totalPoints: 7,
    lastPoints: 7
  },
  {
    id: '6352d39ae1e4df00fa126b16',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8811',
    teamId: '454',
    name: 'Sahil Panwar',
    shortName: 'Sahil Panwar',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '36',
    playingRole: 'Defender',
    points: {
      pid: '8811',
      pname: 'Sahil Panwar',
      points: 50,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 6,
      passes: 4,
      tacklewon: 16,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 20,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.426Z'
    },
    stats: {
      pid: 8811,
      pname: 'Sahil Panwar',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 7,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 5,
      tacklesuccess: 5,
      challengelost: 2,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 60,
      accuratepass: 21,
      totalpass: 35,
      longballsacc: 4,
      totallongballs: 9,
      totalcross: 5,
      crossesacc: 2,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 12,
      duelswon: 12,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.047Z'
    },
    rating: 8.5,
    totalPoints: 50,
    lastPoints: 50
  },
  {
    id: '6352d39ae1e4df00fa126b17',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8822',
    teamId: '451',
    name: 'Sandesh Jhingan',
    shortName: 'Sandesh Jhingan',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '3',
    playingRole: 'Defender',
    points: {
      pid: '8822',
      pname: 'Sandesh Jhingan',
      points: 33,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 3,
      passes: 6,
      tacklewon: 4,
      interceptionwon: 12,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.427Z'
    },
    stats: {
      pid: 8822,
      pname: 'Sandesh Jhingan',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 3,
      interceptionwon: 3,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 62,
      accuratepass: 31,
      totalpass: 50,
      longballsacc: 5,
      totallongballs: 12,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 6,
      duelswon: 6,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.048Z'
    },
    rating: 8.5,
    totalPoints: 33,
    lastPoints: 33
  },
  {
    id: '6352d39ae1e4df00fa126b18',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8828',
    teamId: '454',
    name: 'Lalruatthara',
    shortName: 'Lalruatthara',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b19',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8855',
    teamId: '454',
    name: 'Amrinder Singh',
    shortName: 'Amrinder Singh',
    playingEleven: true,
    role: 'Goalkeeper',
    played: true,
    substitute: false,
    shirtnumber: '1',
    playingRole: 'Goalkeeper',
    points: {
      pid: '8855',
      pname: 'Amrinder Singh',
      points: 33,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 12,
      penaltysaved: 0,
      cleansheet: 20,
      yellowcard: -4,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.428Z'
    },
    stats: {
      pid: 8855,
      pname: 'Amrinder Singh',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 4,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 45.71,
      accuratepass: 16,
      totalpass: 35,
      longballsacc: 10,
      totallongballs: 29,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 1,
      totalrunsout: 1,
      goodhighclaim: 0,
      punches: 1,
      saves: 2,
      savesfrominsidebox: 2,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 1,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.049Z'
    },
    rating: 8,
    totalPoints: 33,
    lastPoints: 33
  },
  {
    id: '6352d39ae1e4df00fa126b1a',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '8915',
    teamId: '454',
    name: 'Jerry Mawihmingthanga',
    shortName: 'Jerry Mawihmingthanga',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '17',
    playingRole: 'Forward',
    points: {
      pid: '8915',
      pname: 'Jerry Mawihmingthanga',
      points: 22,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 12,
      chancecreated: 0,
      passes: 2,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:02.430Z'
    },
    stats: {
      pid: 8915,
      pname: 'Jerry Mawihmingthanga',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 2,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 47.06,
      accuratepass: 8,
      totalpass: 17,
      longballsacc: 0,
      totallongballs: 3,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 1,
      team_id: '454',
      mid: '174223',
      modifiedOn: '2022-10-27T18:22:09.050Z'
    },
    rating: 7.5,
    totalPoints: 22,
    lastPoints: 22
  },
  {
    id: '6352d39ae1e4df00fa126b1b',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '97178',
    teamId: '451',
    name: 'Danish Farooq',
    shortName: 'Danish Farooq',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '12',
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '6352d39ae1e4df00fa126b1c',
    matchId: '6352d31ce1e4df00fa125db2',
    playerId: '97180',
    teamId: '451',
    name: 'Sharon Padattil',
    shortName: 'Sharon Padattil',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4.5,
    totalPoints: 0
  }
];
export const cfcVsBfcResultPlayersList = [
  {
    id: '63445a98746a9884afab3a2c',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '100348',
    teamId: '453',
    name: 'Vincy Barretto',
    shortName: 'Vincy Barretto',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a2d',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '100351',
    teamId: '451',
    name: 'Hira Mondal',
    shortName: 'Hira Mondal',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a2e',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '100362',
    teamId: '451',
    name: 'Bruno Silva Almeida',
    shortName: 'Bruno Silva Almeida',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '6',
    playingRole: 'Midfielder',
    points: {
      pid: '100362',
      pname: 'Bruno Silva Almeida',
      points: 28,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 8,
      tacklewon: 12,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.106Z'
    },
    stats: {
      pid: 100362,
      pname: 'Bruno Silva Almeida',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 4,
      tacklesuccess: 4,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 80.36,
      accuratepass: 45,
      totalpass: 56,
      longballsacc: 3,
      totallongballs: 7,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 7,
      duelswon: 7,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.137Z'
    },
    rating: 8.5,
    totalPoints: 28,
    lastPoints: 28
  },
  {
    id: '63445a98746a9884afab3a2f',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '100377',
    teamId: '453',
    name: 'Alexander Romario Jesuraj',
    shortName: 'Alexander Romario Jesuraj',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a30',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '100411',
    teamId: '453',
    name: 'Mohamed Liyaakath Ahmed',
    shortName: 'Mohamed Liyaakath Ahmed',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a37',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '103385',
    teamId: '453',
    name: 'Devansh Dabas',
    shortName: 'Devansh Dabas',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: true,
    shirtnumber: '35',
    playingRole: 'Goalkeeper',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a3f',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '103386',
    teamId: '453',
    name: 'Subhadip Majhi',
    shortName: 'Subhadip Majhi',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a04',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '10367',
    teamId: '453',
    name: 'Rafael Crivellaro',
    shortName: 'Rafael Crivellaro',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a05',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '11400',
    teamId: '453',
    name: 'Fallou Diagne',
    shortName: 'Fallou Diagne',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '3',
    playingRole: 'Defender',
    points: {
      pid: '11400',
      pname: 'Fallou Diagne',
      points: 25,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 8,
      tacklewon: 4,
      interceptionwon: 8,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.102Z'
    },
    stats: {
      pid: 11400,
      pname: 'Fallou Diagne',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 2,
      tacklecommitted: 3,
      tacklesuccess: 3,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 76.36,
      accuratepass: 42,
      totalpass: 55,
      longballsacc: 3,
      totallongballs: 9,
      totalcross: 1,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.129Z'
    },
    rating: 8.5,
    totalPoints: 25,
    lastPoints: 25
  },
  {
    id: '63445a98746a9884afab3a40',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '135686',
    teamId: '453',
    name: 'Gurmukh Singh',
    shortName: 'Gurmukh Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a41',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '135703',
    teamId: '453',
    name: 'Yumkhaibam Jiteshwor Singh',
    shortName: 'Yumkhaibam Jiteshwor Singh',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '37',
    playingRole: 'Midfielder',
    points: {
      pid: '135703',
      pname: 'Yumkhaibam Jiteshwor Singh',
      points: 32,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 9,
      passes: 7,
      tacklewon: 4,
      interceptionwon: 8,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.106Z'
    },
    stats: {
      pid: 135703,
      pname: 'Yumkhaibam Jiteshwor Singh',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 2,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 3,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 69.57,
      accuratepass: 32,
      totalpass: 46,
      longballsacc: 6,
      totallongballs: 8,
      totalcross: 4,
      crossesacc: 2,
      bigchancecreated: 1,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 3,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.137Z'
    },
    rating: 7,
    totalPoints: 32,
    lastPoints: 32
  },
  {
    id: '63445a98746a9884afab3a42',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '135842',
    teamId: '453',
    name: 'Sangwan Akash',
    shortName: 'Sangwan Akash',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a06',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '17197',
    teamId: '453',
    name: 'Julius Duker',
    shortName: 'Julius Duker',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '26',
    playingRole: 'Midfielder',
    points: {
      pid: '17197',
      pname: 'Julius Duker',
      points: 45,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 9,
      tacklewon: 12,
      interceptionwon: 20,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.102Z'
    },
    stats: {
      pid: 17197,
      pname: 'Julius Duker',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 2,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 4,
      outfielderblock: 0,
      interceptionwon: 5,
      tacklecommitted: 4,
      tacklesuccess: 4,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 78.85,
      accuratepass: 41,
      totalpass: 52,
      longballsacc: 4,
      totallongballs: 7,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.130Z'
    },
    rating: 7,
    totalPoints: 45,
    lastPoints: 45
  },
  {
    id: '63445a98746a9884afab3a43',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '197055',
    teamId: '453',
    name: 'Chris Anthoy White',
    shortName: 'Chris Anthoy White',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a44',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202611',
    teamId: '451',
    name: 'Faisal Ali',
    shortName: 'Faisal Ali',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '19',
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a45',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202622',
    teamId: '453',
    name: 'Monotosh Chakladar',
    shortName: 'Monotosh Chakladar',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a46',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202623',
    teamId: '453',
    name: 'Gulab Rauth',
    shortName: 'Gulab Rauth',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a47',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202624',
    teamId: '453',
    name: 'Sajal Bag',
    shortName: 'Sajal Bag',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '19',
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a48',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202625',
    teamId: '453',
    name: 'Senthamil Shanbagam',
    shortName: 'Senthamil Shanbagam',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a49',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202626',
    teamId: '453',
    name: 'Rahul Manjula',
    shortName: 'Rahul Manjula',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a4a',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202637',
    teamId: '453',
    name: 'Aakash Sangwan',
    shortName: 'Aakash Sangwan',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '27',
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63451e87746a9884afbfde4d',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '202639',
    teamId: '453',
    name: 'Abdenasser El Khayati',
    shortName: 'Abdenasser El Khayati',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a07',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '22155',
    teamId: '451',
    name: 'Javi Hernandez',
    shortName: 'Javi Hernandez',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '10',
    playingRole: 'Midfielder',
    points: {
      pid: '22155',
      pname: 'Javi Hernandez',
      points: 3,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.102Z'
    },
    stats: {
      pid: 22155,
      pname: 'Javi Hernandez',
      teamtype: 'away',
      minutesplayed: 15,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 1,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 87.5,
      accuratepass: 7,
      totalpass: 8,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.131Z'
    },
    rating: 7.5,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '63445a98746a9884afab3a08',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '29488',
    teamId: '453',
    name: 'Salam Singh',
    shortName: 'Salam Singh',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a09',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '29800',
    teamId: '451',
    name: 'Edmund Lalrindika',
    shortName: 'Edmund Lalrindika',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab39f2',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '3093',
    teamId: '451',
    name: 'Alan Costa',
    shortName: 'Alan Costa',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '5',
    playingRole: 'Defender',
    points: {
      pid: '3093',
      pname: 'Alan Costa',
      points: 17,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 3,
      tacklewon: 4,
      interceptionwon: 8,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.098Z'
    },
    stats: {
      pid: 3093,
      pname: 'Alan Costa',
      teamtype: 'away',
      minutesplayed: 75,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 2,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 59.26,
      accuratepass: 16,
      totalpass: 27,
      longballsacc: 3,
      totallongballs: 12,
      totalcross: 1,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.123Z'
    },
    rating: 9,
    totalPoints: 17,
    lastPoints: 17
  },
  {
    id: '63445a98746a9884afab3a0a',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '31049',
    teamId: '451',
    name: 'Parag Satish Shrivas',
    shortName: 'Parag Satish Shrivas',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '2',
    playingRole: 'Defender',
    points: {
      pid: '31049',
      pname: 'Parag Satish Shrivas',
      points: 7,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.102Z'
    },
    stats: {
      pid: 31049,
      pname: 'Parag Satish Shrivas',
      teamtype: 'away',
      minutesplayed: 15,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 66.67,
      accuratepass: 8,
      totalpass: 12,
      longballsacc: 2,
      totallongballs: 3,
      totalcross: 2,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.131Z'
    },
    rating: 7.5,
    totalPoints: 7,
    lastPoints: 7
  },
  {
    id: '63445a98746a9884afab3a0b',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '40384',
    teamId: '453',
    name: 'Petar Sliskovic',
    shortName: 'Petar Sliskovic',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '9',
    playingRole: 'Forward',
    points: {
      pid: '40384',
      pname: 'Petar Sliskovic',
      points: 50,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 20,
      shotsontarget: 18,
      chancecreated: 3,
      passes: 1,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.103Z'
    },
    stats: {
      pid: 40384,
      pname: 'Petar Sliskovic',
      teamtype: 'home',
      minutesplayed: 73,
      assist: 1,
      goals: 0,
      shotsontarget: 3,
      shotsofftarget: 2,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 1,
      penaltywon: 0,
      hitwoodwork: 1,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 61.11,
      accuratepass: 11,
      totalpass: 18,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 1,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.132Z'
    },
    rating: 8.5,
    totalPoints: 50,
    lastPoints: 50
  },
  {
    id: '63445a98746a9884afab3a0c',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '44379',
    teamId: '453',
    name: 'Kwame Karikari',
    shortName: 'Kwame Karikari',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '12',
    playingRole: 'Forward',
    points: {
      pid: '44379',
      pname: 'Kwame Karikari',
      points: 8,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 0,
      passes: 0,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.103Z'
    },
    stats: {
      pid: 44379,
      pname: 'Kwame Karikari',
      teamtype: 'home',
      minutesplayed: 17,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 25,
      accuratepass: 1,
      totalpass: 4,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.132Z'
    },
    rating: 6.5,
    totalPoints: 8,
    lastPoints: 8
  },
  {
    id: '63445a98746a9884afab3a0d',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47144',
    teamId: '451',
    name: 'Suresh Singh Wangjam',
    shortName: 'Suresh Singh Wangjam',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '8',
    playingRole: 'Midfielder',
    points: {
      pid: '47144',
      pname: 'Suresh Singh Wangjam',
      points: 8,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 4,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.103Z'
    },
    stats: {
      pid: 47144,
      pname: 'Suresh Singh Wangjam',
      teamtype: 'away',
      minutesplayed: 75,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 78.13,
      accuratepass: 25,
      totalpass: 32,
      longballsacc: 1,
      totallongballs: 2,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 2,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.133Z'
    },
    rating: 6.5,
    totalPoints: 8,
    lastPoints: 8
  },
  {
    id: '63445a98746a9884afab3a0e',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47147',
    teamId: '453',
    name: 'Jobby Justin',
    shortName: 'Jobby Justin',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '23',
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a0f',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47148',
    teamId: '451',
    name: 'Lara Sharma',
    shortName: 'Lara Sharma',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: true,
    shirtnumber: '30',
    playingRole: 'Goalkeeper',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a10',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47156',
    teamId: '453',
    name: 'Sourav Das',
    shortName: 'Sourav Das',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '18',
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a11',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47166',
    teamId: '451',
    name: 'Amrit Gope',
    shortName: 'Amrit Gope',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a12',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47173',
    teamId: '453',
    name: 'Ninthoi Meetei',
    shortName: 'Ninthoi Meetei',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '7',
    playingRole: 'Midfielder',
    points: {
      pid: '47173',
      pname: 'Ninthoi Meetei',
      points: 5,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 0,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.104Z'
    },
    stats: {
      pid: 47173,
      pname: 'Ninthoi Meetei',
      teamtype: 'home',
      minutesplayed: 11,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 100,
      accuratepass: 1,
      totalpass: 1,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.133Z'
    },
    rating: 8,
    totalPoints: 5,
    lastPoints: 5
  },
  {
    id: '63445a98746a9884afab3a13',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47186',
    teamId: '453',
    name: 'Lovepreet Singh',
    shortName: 'Lovepreet Singh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a14',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '47193',
    teamId: '453',
    name: 'Edwin Vanspaul',
    shortName: 'Edwin Vanspaul',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '8',
    playingRole: 'Midfielder',
    points: {
      pid: '47193',
      pname: 'Edwin Vanspaul',
      points: 3,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.104Z'
    },
    stats: {
      pid: 47193,
      pname: 'Edwin Vanspaul',
      teamtype: 'home',
      minutesplayed: 26,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 1,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 9,
      totalpass: 12,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 2,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.134Z'
    },
    rating: 8.5,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '63445a98746a9884afab3a15',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '56899',
    teamId: '451',
    name: 'Prince Ibara',
    shortName: 'Prince Ibara',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab39f3',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '6018',
    teamId: '451',
    name: 'Roy Krishna',
    shortName: 'Roy Krishna',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '22',
    playingRole: 'Forward',
    points: {
      pid: '6018',
      pname: 'Roy Krishna',
      points: 51,
      starting11: 4,
      substitute: 0,
      goal: 40,
      assist: 0,
      shotsontarget: 6,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: -4,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.098Z'
    },
    stats: {
      pid: 6018,
      pname: 'Roy Krishna',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 1,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 1,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 58.33,
      accuratepass: 7,
      totalpass: 12,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 2,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.123Z'
    },
    rating: 9,
    totalPoints: 51,
    lastPoints: 51
  },
  {
    id: '63445a98746a9884afab3a16',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64021',
    teamId: '451',
    name: 'Namgyal Bhutia',
    shortName: 'Namgyal Bhutia',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '25',
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a17',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64022',
    teamId: '453',
    name: 'Ajith Kumar',
    shortName: 'Ajith Kumar',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '13',
    playingRole: 'Defender',
    points: {
      pid: '64022',
      pname: 'Ajith Kumar',
      points: 30,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 6,
      passes: 6,
      tacklewon: 4,
      interceptionwon: 12,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.104Z'
    },
    stats: {
      pid: 64022,
      pname: 'Ajith Kumar',
      teamtype: 'home',
      minutesplayed: 79,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 1,
      interceptionwon: 3,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 65.85,
      accuratepass: 27,
      totalpass: 41,
      longballsacc: 2,
      totallongballs: 5,
      totalcross: 3,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 3,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.134Z'
    },
    rating: 6.5,
    totalPoints: 30,
    lastPoints: 30
  },
  {
    id: '63445a98746a9884afab3a18',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64024',
    teamId: '451',
    name: 'Wungngayam Muirang',
    shortName: 'Wungngayam Muirang',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a19',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64025',
    teamId: '451',
    name: 'Naorem Roshan Singh',
    shortName: 'Naorem Roshan Singh',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '32',
    playingRole: 'Defender',
    points: {
      pid: '64025',
      pname: 'Naorem Roshan Singh',
      points: 34,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 5,
      tacklewon: 4,
      interceptionwon: 20,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.105Z'
    },
    stats: {
      pid: 64025,
      pname: 'Naorem Roshan Singh',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 1,
      dribbleattempts: 5,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 1,
      interceptionwon: 3,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 74.29,
      accuratepass: 26,
      totalpass: 35,
      longballsacc: 0,
      totallongballs: 3,
      totalcross: 4,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.135Z'
    },
    rating: 8.5,
    totalPoints: 34,
    lastPoints: 34
  },
  {
    id: '63445a98746a9884afab3a1a',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64026',
    teamId: '451',
    name: 'Thoi Singh',
    shortName: 'Thoi Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a1b',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64028',
    teamId: '451',
    name: 'Biswa Darjee',
    shortName: 'Biswa Darjee',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a1c',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64029',
    teamId: '451',
    name: 'Amay Morajkar',
    shortName: 'Amay Morajkar',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a1d',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64041',
    teamId: '453',
    name: 'Samik Mitra',
    shortName: 'Samik Mitra',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a20',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64043',
    teamId: '453',
    name: 'Aqib Nawab',
    shortName: 'Aqib Nawab',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a21',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '64044',
    teamId: '453',
    name: 'Balaji Ganesan',
    shortName: 'Balaji Ganesan',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a22',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '65125',
    teamId: '453',
    name: 'Jockson Dhas',
    shortName: 'Jockson Dhas',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '25',
    playingRole: 'Midfielder',
    points: {
      pid: '65125',
      pname: 'Jockson Dhas',
      points: 2,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 0,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.105Z'
    },
    rating: 7,
    totalPoints: 2,
    lastPoints: 2
  },
  {
    id: '63445a98746a9884afab3a23',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '65129',
    teamId: '453',
    name: 'Syed Suhail Pasha',
    shortName: 'Syed Suhail Pasha',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a24',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '65131',
    teamId: '453',
    name: 'Lijo Francis',
    shortName: 'Lijo Francis',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a25',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '65368',
    teamId: '451',
    name: 'Harmanpreet Singh',
    shortName: 'Harmanpreet Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a26',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '67938',
    teamId: '451',
    name: 'Aleksandar Jovanovic',
    shortName: 'Aleksandar Jovanovic',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '4',
    playingRole: 'Defender',
    points: {
      pid: '67938',
      pname: 'Aleksandar Jovanovic',
      points: 21,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 7,
      tacklewon: 0,
      interceptionwon: 12,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.105Z'
    },
    stats: {
      pid: 67938,
      pname: 'Aleksandar Jovanovic',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 5,
      outfielderblock: 0,
      interceptionwon: 3,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 84.44,
      accuratepass: 38,
      totalpass: 45,
      longballsacc: 7,
      totallongballs: 10,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.135Z'
    },
    rating: 7,
    totalPoints: 21,
    lastPoints: 21
  },
  {
    id: '63445a98746a9884afab3a27',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '76093',
    teamId: '451',
    name: 'Damait Lyngdoh',
    shortName: 'Damait Lyngdoh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a28',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '76094',
    teamId: '451',
    name: 'Sivasakthi Narayanan',
    shortName: 'Sivasakthi Narayanan',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '39',
    playingRole: 'Midfielder',
    points: {
      pid: '76094',
      pname: 'Sivasakthi Narayanan',
      points: 31,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 20,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 0,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.105Z'
    },
    stats: {
      pid: 76094,
      pname: 'Sivasakthi Narayanan',
      teamtype: 'away',
      minutesplayed: 45,
      assist: 1,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 16.67,
      accuratepass: 1,
      totalpass: 6,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 2,
      crossesacc: 1,
      bigchancecreated: 1,
      errorledtogoal: 0,
      dispossessed: 4,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 2,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.136Z'
    },
    rating: 6.5,
    totalPoints: 31,
    lastPoints: 31
  },
  {
    id: '63445a98746a9884afab3a29',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '80010',
    teamId: '453',
    name: 'Vafa Hakhamaneshi',
    shortName: 'Vafa Hakhamaneshi',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '6',
    playingRole: 'Defender',
    points: {
      pid: '80010',
      pname: 'Vafa Hakhamaneshi',
      points: 15,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 5,
      tacklewon: 4,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.106Z'
    },
    stats: {
      pid: 80010,
      pname: 'Vafa Hakhamaneshi',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 5,
      outfielderblock: 1,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 65.85,
      accuratepass: 27,
      totalpass: 41,
      longballsacc: 3,
      totallongballs: 13,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 1,
      fouls: 3,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.136Z'
    },
    rating: 6,
    totalPoints: 15,
    lastPoints: 15
  },
  {
    id: '63445a98746a9884afab39f4',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8640',
    teamId: '451',
    name: 'Sunil Chhetri',
    shortName: 'Sunil Chhetri',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '11',
    playingRole: 'Forward',
    points: {
      pid: '8640',
      pname: 'Sunil Chhetri',
      points: 10,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 3,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.098Z'
    },
    stats: {
      pid: 8640,
      pname: 'Sunil Chhetri',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 86.96,
      accuratepass: 20,
      totalpass: 23,
      longballsacc: 1,
      totallongballs: 2,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.124Z'
    },
    rating: 9,
    totalPoints: 10,
    lastPoints: 10
  },
  {
    id: '63445a98746a9884afab39f5',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8641',
    teamId: '451',
    name: 'Gurpreet Singh Sandhu',
    shortName: 'Gurpreet Singh Sandhu',
    playingEleven: true,
    role: 'Goalkeeper',
    played: true,
    substitute: false,
    shirtnumber: '1',
    playingRole: 'Goalkeeper',
    points: {
      pid: '8641',
      pname: 'Gurpreet Singh Sandhu',
      points: 33,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 30,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.099Z'
    },
    stats: {
      pid: 8641,
      pname: 'Gurpreet Singh Sandhu',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 45.45,
      accuratepass: 15,
      totalpass: 33,
      longballsacc: 4,
      totallongballs: 22,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 5,
      savesfrominsidebox: 5,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.124Z'
    },
    rating: 8.5,
    totalPoints: 33,
    lastPoints: 33
  },
  {
    id: '63445a98746a9884afab39f6',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8649',
    teamId: '451',
    name: 'Udanta Singh',
    shortName: 'Udanta Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '21',
    playingRole: 'Forward',
    points: {
      pid: '8649',
      pname: 'Udanta Singh',
      points: 11,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 2,
      tacklewon: 0,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.099Z'
    },
    stats: {
      pid: 8649,
      pname: 'Udanta Singh',
      teamtype: 'away',
      minutesplayed: 28,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 2,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 61.54,
      accuratepass: 8,
      totalpass: 13,
      longballsacc: 0,
      totallongballs: 1,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.125Z'
    },
    rating: 8.5,
    totalPoints: 11,
    lastPoints: 11
  },
  {
    id: '63445a98746a9884afab39f7',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8670',
    teamId: '451',
    name: 'Leon Agustine Asokan',
    shortName: 'Leon Agustine Asokan',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '31',
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab39f8',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8684',
    teamId: '451',
    name: 'Jayesh Rane',
    shortName: 'Jayesh Rane',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '7',
    playingRole: 'Midfielder',
    points: {
      pid: '8684',
      pname: 'Jayesh Rane',
      points: 8,
      starting11: 0,
      substitute: 2,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 2,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.099Z'
    },
    stats: {
      pid: 8684,
      pname: 'Jayesh Rane',
      teamtype: 'away',
      minutesplayed: 45,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 2,
      dribblesuccess: 2,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 69.23,
      accuratepass: 9,
      totalpass: 13,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.125Z'
    },
    rating: 7.5,
    totalPoints: 8,
    lastPoints: 8
  },
  {
    id: '63445a98746a9884afab39f9',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8687',
    teamId: '451',
    name: 'Prabir Das',
    shortName: 'Prabir Das',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '33',
    playingRole: 'Defender',
    points: {
      pid: '8687',
      pname: 'Prabir Das',
      points: 8,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 2,
      tacklewon: 0,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.099Z'
    },
    stats: {
      pid: 8687,
      pname: 'Prabir Das',
      teamtype: 'away',
      minutesplayed: 62,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 60,
      accuratepass: 12,
      totalpass: 20,
      longballsacc: 1,
      totallongballs: 4,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.126Z'
    },
    rating: 8,
    totalPoints: 8,
    lastPoints: 8
  },
  {
    id: '63445a98746a9884afab39fa',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8694',
    teamId: '453',
    name: 'Debjit Majumder',
    shortName: 'Debjit Majumder',
    playingEleven: true,
    role: 'Goalkeeper',
    played: true,
    substitute: false,
    shirtnumber: '24',
    playingRole: 'Goalkeeper',
    points: {
      pid: '8694',
      pname: 'Debjit Majumder',
      points: -7,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 1,
      tacklewon: 0,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: -10,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.100Z'
    },
    stats: {
      pid: 8694,
      pname: 'Debjit Majumder',
      teamtype: 'home',
      minutesplayed: 82,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 52.94,
      accuratepass: 9,
      totalpass: 17,
      longballsacc: 4,
      totallongballs: 12,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 1,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.126Z'
    },
    rating: 8.5,
    totalPoints: -7,
    lastPoints: -7
  },
  {
    id: '63445a98746a9884afab39fb',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8724',
    teamId: '453',
    name: 'Anirudh Thapa',
    shortName: 'Anirudh Thapa',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '15',
    playingRole: 'Midfielder',
    points: {
      pid: '8724',
      pname: 'Anirudh Thapa',
      points: 19,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 3,
      passes: 8,
      tacklewon: 4,
      interceptionwon: 0,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.100Z'
    },
    stats: {
      pid: 8724,
      pname: 'Anirudh Thapa',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 2,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 85.71,
      accuratepass: 42,
      totalpass: 49,
      longballsacc: 7,
      totallongballs: 8,
      totalcross: 5,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.127Z'
    },
    rating: 9,
    totalPoints: 19,
    lastPoints: 19
  },
  {
    id: '63445a98746a9884afab39fc',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8730',
    teamId: '453',
    name: 'Rahim Ali',
    shortName: 'Rahim Ali',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '11',
    playingRole: 'Forward',
    points: {
      pid: '8730',
      pname: 'Rahim Ali',
      points: 11,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 3,
      tacklewon: 0,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.100Z'
    },
    stats: {
      pid: 8730,
      pname: 'Rahim Ali',
      teamtype: 'home',
      minutesplayed: 79,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 1,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 18,
      totalpass: 24,
      longballsacc: 1,
      totallongballs: 4,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.127Z'
    },
    rating: 8,
    totalPoints: 11,
    lastPoints: 11
  },
  {
    id: '63445a98746a9884afab39fd',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8745',
    teamId: '453',
    name: 'Mohammad Sajid Dhot',
    shortName: 'Mohammad Sajid Dhot',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab39fe',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8766',
    teamId: '453',
    name: 'Narayan Das',
    shortName: 'Narayan Das',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '21',
    playingRole: 'Defender',
    points: {
      pid: '8766',
      pname: 'Narayan Das',
      points: 22,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 6,
      passes: 6,
      tacklewon: 4,
      interceptionwon: 4,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.101Z'
    },
    stats: {
      pid: 8766,
      pname: 'Narayan Das',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 2,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 94.12,
      accuratepass: 32,
      totalpass: 34,
      longballsacc: 4,
      totallongballs: 6,
      totalcross: 5,
      crossesacc: 4,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.128Z'
    },
    rating: 7.5,
    totalPoints: 22,
    lastPoints: 22
  },
  {
    id: '63445a98746a9884afab39ff',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8806',
    teamId: '451',
    name: 'Rohit Kumar',
    shortName: 'Rohit Kumar',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a00',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8822',
    teamId: '451',
    name: 'Sandesh Jhingan',
    shortName: 'Sandesh Jhingan',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '3',
    playingRole: 'Defender',
    points: {
      pid: '8822',
      pname: 'Sandesh Jhingan',
      points: 23,
      starting11: 4,
      substitute: 0,
      goal: 0,
      assist: 0,
      shotsontarget: 0,
      chancecreated: 0,
      passes: 5,
      tacklewon: 4,
      interceptionwon: 12,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -2,
      penaltymissed: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.101Z'
    },
    stats: {
      pid: 8822,
      pname: 'Sandesh Jhingan',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 3,
      outfielderblock: 0,
      interceptionwon: 3,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 82.76,
      accuratepass: 24,
      totalpass: 29,
      longballsacc: 2,
      totallongballs: 3,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '451',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.128Z'
    },
    rating: 8.5,
    totalPoints: 23,
    lastPoints: 23
  },
  {
    id: '63445a98746a9884afab3a01',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8832',
    teamId: '453',
    name: 'K Prasanth',
    shortName: 'K Prasanth',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '66',
    playingRole: 'Midfielder',
    points: {
      pid: '8832',
      pname: 'K Prasanth',
      points: 91,
      starting11: 4,
      substitute: 0,
      goal: 50,
      assist: 0,
      shotsontarget: 12,
      chancecreated: 6,
      passes: 3,
      tacklewon: 8,
      interceptionwon: 8,
      saves: 0,
      penaltysaved: 0,
      cleansheet: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:04.101Z'
    },
    stats: {
      pid: 8832,
      pname: 'K Prasanth',
      teamtype: 'home',
      minutesplayed: 64,
      assist: 0,
      goals: 1,
      shotsontarget: 2,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 2,
      tacklecommitted: 4,
      tacklesuccess: 4,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 87.5,
      accuratepass: 14,
      totalpass: 16,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 4,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174215',
      modifiedOn: '2022-10-14T18:46:11.129Z'
    },
    rating: 7.5,
    totalPoints: 91,
    lastPoints: 91
  },
  {
    id: '63445a98746a9884afab3a02',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '8859',
    teamId: '453',
    name: 'Mohammed Rafique',
    shortName: 'Mohammed Rafique',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a2a',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '97178',
    teamId: '451',
    name: 'Danish Farooq',
    shortName: 'Danish Farooq',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '12',
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a2b',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '97180',
    teamId: '451',
    name: 'Sharon Padattil',
    shortName: 'Sharon Padattil',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63445a98746a9884afab3a03',
    matchId: '63445a1c746a9884afab2c59',
    playerId: '9811',
    teamId: '453',
    name: 'Nasser El Khayati',
    shortName: 'Nasser El Khayati',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  }
];

export const atkMBVsCfcPlayerList = [
  {
    id: '633fb1e0746a9884af2fbe69',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '100348',
    teamId: '453',
    name: 'Vincy Barretto',
    shortName: 'Vincy Barretto',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe6a',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '100355',
    teamId: '2029',
    name: 'Lalrinliana Hnamte',
    shortName: 'Lalrinliana Hnamte',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '14',
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe6b',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '100377',
    teamId: '453',
    name: 'Alexander Romario Jesuraj',
    shortName: 'Alexander Romario Jesuraj',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe6c',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '103385',
    teamId: '453',
    name: 'Devansh Dabas',
    shortName: 'Devansh Dabas',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: true,
    shirtnumber: '35',
    playingRole: 'Goalkeeper',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe6d',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '103386',
    teamId: '453',
    name: 'Subhadip Majhi',
    shortName: 'Subhadip Majhi',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe42',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '10367',
    teamId: '453',
    name: 'Rafael Crivellaro',
    shortName: 'Rafael Crivellaro',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe6e',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '109511',
    teamId: '2029',
    name: 'Sumit Rathi',
    shortName: 'Sumit Rathi',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '2',
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe43',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '11400',
    teamId: '453',
    name: 'Fallou Diagne',
    shortName: 'Fallou Diagne',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '3',
    playingRole: 'Defender',
    points: {
      pid: 11400,
      pname: 'Fallou Diagne',
      points: 2.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.996Z'
    },
    stats: {
      pid: 11400,
      pname: 'Fallou Diagne',
      teamtype: 'away',
      minutesplayed: 58,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 4,
      outfielderblock: 0,
      interceptionwon: 4,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 85,
      accuratepass: 17,
      totalpass: 20,
      longballsacc: 2,
      totallongballs: 5,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.941Z'
    },
    rating: 8,
    totalPoints: 2.5,
    lastPoints: 2.5
  },
  {
    id: '633fb1e0746a9884af2fbe6f',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '115916',
    teamId: '2029',
    name: 'Ricky John Shabong',
    shortName: 'Ricky John Shabong',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe70',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '135686',
    teamId: '453',
    name: 'Gurmukh Singh',
    shortName: 'Gurmukh Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '4',
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe71',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '135703',
    teamId: '453',
    name: 'Yumkhaibam Jiteshwor Singh',
    shortName: 'Yumkhaibam Jiteshwor Singh',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '37',
    playingRole: 'Midfielder',
    points: {
      pid: 135703,
      pname: 'Yumkhaibam Jiteshwor Singh',
      points: 3,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 1,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:02.001Z'
    },
    stats: {
      pid: 135703,
      pname: 'Yumkhaibam Jiteshwor Singh',
      teamtype: 'away',
      minutesplayed: 59,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 2,
      interceptionwon: 2,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 2,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 81.48,
      accuratepass: 22,
      totalpass: 27,
      longballsacc: 1,
      totallongballs: 3,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.949Z'
    },
    rating: 7.5,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '633fb1e0746a9884af2fbe72',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '135842',
    teamId: '453',
    name: 'Sangwan Akash',
    shortName: 'Sangwan Akash',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe44',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '14021',
    teamId: '2029',
    name: 'Joni Kauko',
    shortName: 'Joni Kauko',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '7',
    playingRole: 'Midfielder',
    points: {
      pid: 14021,
      pname: 'Joni Kauko',
      points: 5.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 1.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 2,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.997Z'
    },
    stats: {
      pid: 14021,
      pname: 'Joni Kauko',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 2,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 6,
      tacklesuccess: 6,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 80.95,
      accuratepass: 34,
      totalpass: 42,
      longballsacc: 1,
      totallongballs: 3,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 7,
      duelswon: 7,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.942Z'
    },
    rating: 9,
    totalPoints: 5.5,
    lastPoints: 5.5
  },
  {
    id: '633fb1e0746a9884af2fbe45',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '17197',
    teamId: '453',
    name: 'Julius Duker',
    shortName: 'Julius Duker',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '26',
    playingRole: 'Forward',
    points: {
      pid: 17197,
      pname: 'Julius Duker',
      points: 4,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 2,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.997Z'
    },
    stats: {
      pid: 17197,
      pname: 'Julius Duker',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 3,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 85.71,
      accuratepass: 48,
      totalpass: 56,
      longballsacc: 2,
      totallongballs: 6,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.942Z'
    },
    rating: 8.5,
    totalPoints: 4,
    lastPoints: 4
  },
  {
    id: '633fb1e0746a9884af2fbe73',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '197055',
    teamId: '453',
    name: 'Chris Anthoy White',
    shortName: 'Chris Anthoy White',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 0,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe74',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '197697',
    teamId: '2029',
    name: 'Debnath Mondal',
    shortName: 'Debnath Mondal',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 0,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe75',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '202622',
    teamId: '453',
    name: 'Monotosh Chakladar',
    shortName: 'Monotosh Chakladar',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 0,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe76',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '202623',
    teamId: '453',
    name: 'Gulab Rauth',
    shortName: 'Gulab Rauth',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 0,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe77',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '202624',
    teamId: '453',
    name: 'Sajal Bag',
    shortName: 'Sajal Bag',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '19',
    playingRole: 'Midfielder',
    rating: 0,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe78',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '202625',
    teamId: '453',
    name: 'Senthamil Shanbagam',
    shortName: 'Senthamil Shanbagam',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 0,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe79',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '202626',
    teamId: '453',
    name: 'Rahul Manjula',
    shortName: 'Rahul Manjula',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 0,
    totalPoints: 0
  },
  {
    id: '63441b4f746a9884afa46c15',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '202637',
    teamId: '453',
    name: 'Aakash Sangwan',
    shortName: 'Aakash Sangwan',
    playingEleven: false,
    played: false,
    substitute: true,
    shirtnumber: '27',
    points: {
      pid: 202637,
      pname: 'Aakash Sangwan',
      points: 1,
      minutesplayed: 1,
      goalscored: 0,
      assist: 0,
      passes: 0,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:02.001Z'
    },
    stats: {
      pid: 202637,
      pname: 'Aakash Sangwan',
      teamtype: 'away',
      minutesplayed: 31,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 1,
      interceptionwon: 2,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 100,
      accuratepass: 7,
      totalpass: 7,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 1,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.950Z'
    },
    rating: null,
    totalPoints: 1,
    lastPoints: 1
  },
  {
    id: '63441ad8746a9884afa45f9d',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '202639',
    teamId: '453',
    name: 'Abdenasser El  Khayati',
    shortName: 'Abdenasser El  Khayati',
    playingEleven: false,
    played: false,
    substitute: true,
    shirtnumber: '99',
    stats: {
      pid: 202639,
      pname: 'Abdenasser El Khayati',
      teamtype: 'away',
      minutesplayed: 8,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 85.71,
      accuratepass: 6,
      totalpass: 7,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: '',
      cleansheet: '',
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.951Z'
    },
    rating: null,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe46',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '22826',
    teamId: '2029',
    name: 'Carl McHugh',
    shortName: 'Carl McHugh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '8',
    playingRole: 'Midfielder',
    points: {
      pid: 22826,
      pname: 'Carl McHugh',
      points: 2.5,
      minutesplayed: 1,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 1,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.997Z'
    },
    stats: {
      pid: 22826,
      pname: 'Carl McHugh',
      teamtype: 'home',
      minutesplayed: 23,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 1,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 3,
      tacklesuccess: 3,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 82.35,
      accuratepass: 14,
      totalpass: 17,
      longballsacc: 2,
      totallongballs: 2,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.943Z'
    },
    rating: 8.5,
    totalPoints: 2.5,
    lastPoints: 2.5
  },
  {
    id: '633fb1e0746a9884af2fbe47',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '28154',
    teamId: '2029',
    name: 'Avilash Paul',
    shortName: 'Avilash Paul',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe48',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '29488',
    teamId: '453',
    name: 'Salam Singh',
    shortName: 'Salam Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe49',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '31993',
    teamId: '2029',
    name: 'Florentin Pogba',
    shortName: 'Florentin Pogba',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '6',
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe2d',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '399',
    teamId: '2029',
    name: 'Dimitri Petratos',
    shortName: 'Dimitri Petratos',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '9',
    playingRole: 'Midfielder',
    points: {
      pid: 399,
      pname: 'Dimitri Petratos',
      points: 7.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 5,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.991Z'
    },
    stats: {
      pid: 399,
      pname: 'Dimitri Petratos',
      teamtype: 'home',
      minutesplayed: 67,
      assist: 1,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 1,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 91.67,
      accuratepass: 11,
      totalpass: 12,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 1,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.933Z'
    },
    rating: 9,
    totalPoints: 7.5,
    lastPoints: 7.5
  },
  {
    id: '633fb1e0746a9884af2fbe4a',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '40384',
    teamId: '453',
    name: 'Petar Sliskovic',
    shortName: 'Petar Sliskovic',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '9',
    playingRole: 'Forward',
    points: {
      pid: 40384,
      pname: 'Petar Sliskovic',
      points: 2.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.998Z'
    },
    stats: {
      pid: 40384,
      pname: 'Petar Sliskovic',
      teamtype: 'away',
      minutesplayed: 82,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 77.78,
      accuratepass: 14,
      totalpass: 18,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.943Z'
    },
    rating: 9.5,
    totalPoints: 2.5,
    lastPoints: 2.5
  },
  {
    id: '633fb1e0746a9884af2fbe4b',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '44379',
    teamId: '453',
    name: 'Kwame Karikari',
    shortName: 'Kwame Karikari',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '12',
    playingRole: 'Forward',
    points: {
      pid: 44379,
      pname: 'Kwame Karikari',
      points: 14,
      minutesplayed: 1,
      goalscored: 8,
      assist: 5,
      passes: 0,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.998Z'
    },
    stats: {
      pid: 44379,
      pname: 'Kwame Karikari',
      teamtype: 'away',
      minutesplayed: 32,
      assist: 1,
      goals: 1,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 1,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 6,
      totalpass: 8,
      longballsacc: 0,
      totallongballs: 2,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.944Z'
    },
    rating: 9,
    totalPoints: 14,
    lastPoints: 14
  },
  {
    id: '633fb1e0746a9884af2fbe4c',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '47147',
    teamId: '453',
    name: 'Jobby Justin',
    shortName: 'Jobby Justin',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '23',
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe4d',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '47156',
    teamId: '453',
    name: 'Sourav Das',
    shortName: 'Sourav Das',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '18',
    playingRole: 'Midfielder',
    points: {
      pid: 47156,
      pname: 'Sourav Das',
      points: 0,
      minutesplayed: 1,
      goalscored: 0,
      assist: 0,
      passes: 0,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: -1,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.999Z'
    },
    stats: {
      pid: 47156,
      pname: 'Sourav Das',
      teamtype: 'away',
      minutesplayed: 18,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 80,
      accuratepass: 4,
      totalpass: 5,
      longballsacc: 0,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 1,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 1,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.944Z'
    },
    rating: 8.5,
    totalPoints: 0,
    lastPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe4e',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '47173',
    teamId: '453',
    name: 'Ninthoi Meetei',
    shortName: 'Ninthoi Meetei',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe4f',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '47186',
    teamId: '453',
    name: 'Lovepreet Singh',
    shortName: 'Lovepreet Singh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe50',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '47193',
    teamId: '453',
    name: 'Edwin Vanspaul',
    shortName: 'Edwin Vanspaul',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '8',
    playingRole: 'Midfielder',
    points: {
      pid: 47193,
      pname: 'Edwin Vanspaul',
      points: 1.5,
      minutesplayed: 1,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.999Z'
    },
    stats: {
      pid: 47193,
      pname: 'Edwin Vanspaul',
      teamtype: 'away',
      minutesplayed: 45,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 83.33,
      accuratepass: 10,
      totalpass: 12,
      longballsacc: 1,
      totallongballs: 2,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 0,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.945Z'
    },
    rating: 8.5,
    totalPoints: 1.5,
    lastPoints: 1.5
  },
  {
    id: '633fb1e0746a9884af2fbe51',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '47197',
    teamId: '2029',
    name: 'Asish Rai',
    shortName: 'Asish Rai',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '44',
    playingRole: 'Defender',
    points: {
      pid: 47197,
      pname: 'Asish Rai',
      points: 3.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 1,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:02.000Z'
    },
    stats: {
      pid: 47197,
      pname: 'Asish Rai',
      teamtype: 'home',
      minutesplayed: 67,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 4,
      tacklesuccess: 4,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 76.19,
      accuratepass: 16,
      totalpass: 21,
      longballsacc: 2,
      totallongballs: 2,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 8,
      duelswon: 8,
      wasfouled: 2,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.946Z'
    },
    rating: 8.5,
    totalPoints: 3.5,
    lastPoints: 3.5
  },
  {
    id: '633fb1e0746a9884af2fbe52',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '49182',
    teamId: '2029',
    name: 'Arsh Anwer Shaikh',
    shortName: 'Arsh Anwer Shaikh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: true,
    shirtnumber: '31',
    playingRole: 'Goalkeeper',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe2e',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '6066',
    teamId: '2029',
    name: 'Brendan Hamill',
    shortName: 'Brendan Hamill',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '5',
    playingRole: 'Defender',
    points: {
      pid: 6066,
      pname: 'Brendan Hamill',
      points: 3,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 2,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -1,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.992Z'
    },
    stats: {
      pid: 6066,
      pname: 'Brendan Hamill',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 3,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 1,
      tacklesuccess: 1,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 94.12,
      accuratepass: 48,
      totalpass: 51,
      longballsacc: 1,
      totallongballs: 2,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.934Z'
    },
    rating: 9,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '633fb1e0746a9884af2fbe53',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '64022',
    teamId: '453',
    name: 'Ajith Kumar',
    shortName: 'Ajith Kumar',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '13',
    playingRole: 'Defender',
    points: {
      pid: 64022,
      pname: 'Ajith Kumar',
      points: 2.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 1,
      yellowcard: -1,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:02.000Z'
    },
    stats: {
      pid: 64022,
      pname: 'Ajith Kumar',
      teamtype: 'away',
      minutesplayed: 72,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 2,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 2,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 5,
      tacklesuccess: 5,
      challengelost: 2,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 78.95,
      accuratepass: 15,
      totalpass: 19,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 6,
      duelswon: 6,
      wasfouled: 0,
      fouls: 4,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 1,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.946Z'
    },
    rating: 8.5,
    totalPoints: 2.5,
    lastPoints: 2.5
  },
  {
    id: '633fb1e0746a9884af2fbe54',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '64041',
    teamId: '453',
    name: 'Samik Mitra',
    shortName: 'Samik Mitra',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe55',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '64043',
    teamId: '453',
    name: 'Aqib Nawab',
    shortName: 'Aqib Nawab',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe56',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '64044',
    teamId: '453',
    name: 'Balaji Ganesan',
    shortName: 'Balaji Ganesan',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe57',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '65125',
    teamId: '453',
    name: 'Jockson Dhas',
    shortName: 'Jockson Dhas',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe58',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '65129',
    teamId: '453',
    name: 'Syed Suhail Pasha',
    shortName: 'Syed Suhail Pasha',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe59',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '65131',
    teamId: '453',
    name: 'Lijo Francis',
    shortName: 'Lijo Francis',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe5a',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '65301',
    teamId: '2029',
    name: 'Ningombam Engson Singh',
    shortName: 'Ningombam Engson Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe5b',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '65303',
    teamId: '2029',
    name: 'Md Fardin Ali Molla',
    shortName: 'Md Fardin Ali Molla',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: true,
    shirtnumber: '27',
    playingRole: 'Forward',
    stats: {
      pid: 65303,
      pname: 'Md Fardin Ali Molla',
      teamtype: 'home',
      minutesplayed: 22,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 0,
      accuratepass: 0,
      totalpass: 0,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: '',
      cleansheet: '',
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.947Z'
    },
    rating: 9,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe5c',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '80010',
    teamId: '453',
    name: 'Vafa Hakhamaneshi',
    shortName: 'Vafa Hakhamaneshi',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '6',
    playingRole: 'Defender',
    points: {
      pid: 80010,
      pname: 'Vafa Hakhamaneshi',
      points: 2.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:02.001Z'
    },
    stats: {
      pid: 80010,
      pname: 'Vafa Hakhamaneshi',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 9,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 18,
      totalpass: 24,
      longballsacc: 4,
      totallongballs: 6,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 6,
      duelswon: 6,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.947Z'
    },
    rating: 7.5,
    totalPoints: 2.5,
    lastPoints: 2.5
  },
  {
    id: '633fb1e0746a9884af2fbe2f',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8663',
    teamId: '2029',
    name: 'Subashish Bose',
    shortName: 'Subashish Bose',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '15',
    playingRole: 'Defender',
    points: {
      pid: 8663,
      pname: 'Subashish Bose',
      points: 3.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 2.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -1,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.992Z'
    },
    stats: {
      pid: 8663,
      pname: 'Subashish Bose',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 1,
      interceptionwon: 1,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 88.71,
      accuratepass: 55,
      totalpass: 62,
      longballsacc: 4,
      totallongballs: 6,
      totalcross: 1,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.934Z'
    },
    rating: 8.5,
    totalPoints: 3.5,
    lastPoints: 3.5
  },
  {
    id: '633fb1e0746a9884af2fbe30',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8694',
    teamId: '453',
    name: 'Debjit Majumder',
    shortName: 'Debjit Majumder',
    playingEleven: true,
    role: 'Goalkeeper',
    played: true,
    substitute: false,
    shirtnumber: '24',
    playingRole: 'Goalkeeper',
    points: {
      pid: 8694,
      pname: 'Debjit Majumder',
      points: 6.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 4,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.992Z'
    },
    stats: {
      pid: 8694,
      pname: 'Debjit Majumder',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 3,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 1,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 62.5,
      accuratepass: 10,
      totalpass: 16,
      longballsacc: 3,
      totallongballs: 9,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 1,
      totalrunsout: 1,
      goodhighclaim: 1,
      punches: 0,
      saves: 6,
      savesfrominsidebox: 2,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.935Z'
    },
    rating: 8.5,
    totalPoints: 6.5,
    lastPoints: 6.5
  },
  {
    id: '633fb1e0746a9884af2fbe31',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8724',
    teamId: '453',
    name: 'Anirudh Thapa',
    shortName: 'Anirudh Thapa',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '15',
    playingRole: 'Midfielder',
    points: {
      pid: 8724,
      pname: 'Anirudh Thapa',
      points: 3,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 1,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.993Z'
    },
    stats: {
      pid: 8724,
      pname: 'Anirudh Thapa',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 2,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75,
      accuratepass: 27,
      totalpass: 36,
      longballsacc: 2,
      totallongballs: 3,
      totalcross: 6,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 3,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.935Z'
    },
    rating: 9,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '633fb1e0746a9884af2fbe32',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8729',
    teamId: '2029',
    name: 'Deepak Tangri',
    shortName: 'Deepak Tangri',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '22',
    playingRole: 'Midfielder',
    points: {
      pid: 8729,
      pname: 'Deepak Tangri',
      points: 3,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 2,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -1,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.993Z'
    },
    stats: {
      pid: 8729,
      pname: 'Deepak Tangri',
      teamtype: 'home',
      minutesplayed: 83,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 84.21,
      accuratepass: 48,
      totalpass: 57,
      longballsacc: 1,
      totallongballs: 4,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.936Z'
    },
    rating: 8.5,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '633fb1e0746a9884af2fbe33',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8730',
    teamId: '453',
    name: 'Rahim Ali',
    shortName: 'Rahim Ali',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '11',
    playingRole: 'Forward',
    points: {
      pid: 8730,
      pname: 'Rahim Ali',
      points: 12,
      minutesplayed: 2,
      goalscored: 8,
      assist: 0,
      passes: 1,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 1,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.993Z'
    },
    stats: {
      pid: 8730,
      pname: 'Rahim Ali',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 1,
      shotsontarget: 1,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 3,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 1,
      interceptionwon: 1,
      tacklecommitted: 3,
      tacklesuccess: 3,
      challengelost: 1,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 87.5,
      accuratepass: 21,
      totalpass: 24,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 3,
      duelswon: 3,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.937Z'
    },
    rating: 9,
    totalPoints: 12,
    lastPoints: 12
  },
  {
    id: '633fb1e0746a9884af2fbe34',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8739',
    teamId: '2029',
    name: 'Pritam Kotal',
    shortName: 'Pritam Kotal',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '20',
    playingRole: 'Defender',
    points: {
      pid: 8739,
      pname: 'Pritam Kotal',
      points: 3,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 2,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -1,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.994Z'
    },
    stats: {
      pid: 8739,
      pname: 'Pritam Kotal',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 4,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 80,
      accuratepass: 44,
      totalpass: 55,
      longballsacc: 3,
      totallongballs: 8,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.937Z'
    },
    rating: 9,
    totalPoints: 3,
    lastPoints: 3
  },
  {
    id: '633fb1e0746a9884af2fbe35',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8745',
    teamId: '453',
    name: 'Mohammad Sajid Dhot',
    shortName: 'Mohammad Sajid Dhot',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe36',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8764',
    teamId: '2029',
    name: 'Lenny Rodrigues',
    shortName: 'Lenny Rodrigues',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '24',
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe37',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8765',
    teamId: '2029',
    name: 'Hugo Boumous',
    shortName: 'Hugo Boumous',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '10',
    playingRole: 'Midfielder',
    points: {
      pid: 8765,
      pname: 'Hugo Boumous',
      points: 4,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 2,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.994Z'
    },
    stats: {
      pid: 8765,
      pname: 'Hugo Boumous',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 5,
      dribblesuccess: 3,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 2,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 78.43,
      accuratepass: 40,
      totalpass: 51,
      longballsacc: 4,
      totallongballs: 5,
      totalcross: 9,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 2,
      duelstotal: 5,
      duelswon: 5,
      wasfouled: 2,
      fouls: 2,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 4,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.938Z'
    },
    rating: 9.5,
    totalPoints: 4,
    lastPoints: 4
  },
  {
    id: '633fb1e0746a9884af2fbe38',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8766',
    teamId: '453',
    name: 'Narayan Das',
    shortName: 'Narayan Das',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '21',
    playingRole: 'Defender',
    points: {
      pid: 8766,
      pname: 'Narayan Das',
      points: 2.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.994Z'
    },
    stats: {
      pid: 8766,
      pname: 'Narayan Das',
      teamtype: 'away',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 1,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 2,
      tacklesuccess: 2,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 68,
      accuratepass: 17,
      totalpass: 25,
      longballsacc: 2,
      totallongballs: 6,
      totalcross: 5,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 2,
      duelswon: 2,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.938Z'
    },
    rating: 8.5,
    totalPoints: 2.5,
    lastPoints: 2.5
  },
  {
    id: '633fb1e0746a9884af2fbe39',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8768',
    teamId: '2029',
    name: 'Pronay Halder',
    shortName: 'Pronay Halder',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe3a',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8776',
    teamId: '2029',
    name: 'Manvir Singh',
    shortName: 'Manvir Singh',
    playingEleven: true,
    role: 'Forward',
    played: true,
    substitute: false,
    shirtnumber: '11',
    playingRole: 'Forward',
    points: {
      pid: 8776,
      pname: 'Manvir Singh',
      points: 11,
      minutesplayed: 2,
      goalscored: 8,
      assist: 0,
      passes: 1,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.995Z'
    },
    stats: {
      pid: 8776,
      pname: 'Manvir Singh',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 1,
      shotsontarget: 1,
      shotsofftarget: 1,
      shotsblocked: 0,
      dribbleattempts: 3,
      dribblesuccess: 1,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 1,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 75.76,
      accuratepass: 25,
      totalpass: 33,
      longballsacc: 0,
      totallongballs: 2,
      totalcross: 2,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 4,
      duelswon: 4,
      wasfouled: 1,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.939Z'
    },
    rating: 9,
    totalPoints: 11,
    lastPoints: 11
  },
  {
    id: '633fb1e0746a9884af2fbe3b',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8781',
    teamId: '2029',
    name: 'Liston Colaco',
    shortName: 'Liston Colaco',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: true,
    shirtnumber: '17',
    playingRole: 'Midfielder',
    points: {
      pid: 8781,
      pname: 'Liston Colaco',
      points: 2,
      minutesplayed: 1,
      goalscored: 0,
      assist: 0,
      passes: 0,
      shotsontarget: 1,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.995Z'
    },
    stats: {
      pid: 8781,
      pname: 'Liston Colaco',
      teamtype: 'home',
      minutesplayed: 23,
      assist: 0,
      goals: 0,
      shotsontarget: 2,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 4,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 61.54,
      accuratepass: 8,
      totalpass: 13,
      longballsacc: 1,
      totallongballs: 1,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 1,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 1,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.939Z'
    },
    rating: 9.5,
    totalPoints: 2,
    lastPoints: 2
  },
  {
    id: '633fb1e0746a9884af2fbe3c',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8801',
    teamId: '2029',
    name: 'Ashique Kuruniyan',
    shortName: 'Ashique Kuruniyan',
    playingEleven: true,
    role: 'Defender',
    played: true,
    substitute: false,
    shirtnumber: '19',
    playingRole: 'Defender',
    points: {
      pid: 8801,
      pname: 'Ashique Kuruniyan',
      points: 4,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 1,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 1,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.995Z'
    },
    stats: {
      pid: 8801,
      pname: 'Ashique Kuruniyan',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 1,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 9,
      dribblesuccess: 4,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 1,
      interceptionwon: 2,
      tacklecommitted: 4,
      tacklesuccess: 4,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 78.79,
      accuratepass: 26,
      totalpass: 33,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 7,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 10,
      duelswon: 10,
      wasfouled: 2,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 2,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.940Z'
    },
    rating: 8.5,
    totalPoints: 4,
    lastPoints: 4
  },
  {
    id: '633fb1e0746a9884af2fbe3d',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8802',
    teamId: '2029',
    name: 'Vishal Kaith',
    shortName: 'Vishal Kaith',
    playingEleven: true,
    role: 'Goalkeeper',
    played: true,
    substitute: false,
    shirtnumber: '1',
    playingRole: 'Goalkeeper',
    points: {
      pid: 8802,
      pname: 'Vishal Kaith',
      points: 1.5,
      minutesplayed: 2,
      goalscored: 0,
      assist: 0,
      passes: 0.5,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: -1,
      penaltymissed: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.996Z'
    },
    stats: {
      pid: 8802,
      pname: 'Vishal Kaith',
      teamtype: 'home',
      minutesplayed: 90,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 0,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 1,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 1,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 76.47,
      accuratepass: 13,
      totalpass: 17,
      longballsacc: 2,
      totallongballs: 6,
      totalcross: 0,
      crossesacc: 0,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 1,
      duelswon: 1,
      wasfouled: 0,
      fouls: 1,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 1,
      punches: 1,
      saves: 1,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 2,
      cleansheet: 0,
      team_id: '2029',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.940Z'
    },
    rating: 8.5,
    totalPoints: 1.5,
    lastPoints: 1.5
  },
  {
    id: '633fb1e0746a9884af2fbe3e',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8832',
    teamId: '453',
    name: 'K Prasanth',
    shortName: 'K Prasanth',
    playingEleven: true,
    role: 'Midfielder',
    played: true,
    substitute: false,
    shirtnumber: '66',
    playingRole: 'Midfielder',
    points: {
      pid: 8832,
      pname: 'K Prasanth',
      points: 1,
      minutesplayed: 1,
      goalscored: 0,
      assist: 0,
      passes: 0,
      shotsontarget: 0,
      cleansheet: 0,
      shotssaved: 0,
      penaltysaved: 0,
      tacklesuccessful: 0,
      yellowcard: 0,
      redcard: 0,
      owngoal: 0,
      goalsconceded: 0,
      penaltymissed: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:01.996Z'
    },
    stats: {
      pid: 8832,
      pname: 'K Prasanth',
      teamtype: 'away',
      minutesplayed: 45,
      assist: 0,
      goals: 0,
      shotsontarget: 0,
      shotsofftarget: 0,
      shotsblocked: 0,
      dribbleattempts: 2,
      dribblesuccess: 0,
      bigchancemissed: 0,
      penaltywon: 0,
      hitwoodwork: 0,
      penaltymiss: 0,
      totalclearance: 0,
      outfielderblock: 0,
      interceptionwon: 0,
      tacklecommitted: 0,
      tacklesuccess: 0,
      challengelost: 0,
      owngoals: 0,
      penaltycommitted: 0,
      errorledtoshot: 0,
      lastmantackle: 0,
      clearanceoffline: 0,
      passingaccuracy: 100,
      accuratepass: 5,
      totalpass: 5,
      longballsacc: 0,
      totallongballs: 0,
      totalcross: 2,
      crossesacc: 1,
      bigchancecreated: 0,
      errorledtogoal: 0,
      dispossessed: 0,
      duelstotal: 0,
      duelswon: 0,
      wasfouled: 0,
      fouls: 0,
      runsoutsucess: 0,
      totalrunsout: 0,
      goodhighclaim: 0,
      punches: 0,
      saves: 0,
      savesfrominsidebox: 0,
      penaltysave: 0,
      keypass: 0,
      yellowcard: 0,
      redcard: 0,
      goalconceded: 1,
      cleansheet: 0,
      team_id: '453',
      mid: '174211',
      modifiedOn: '2022-10-10T19:26:07.941Z'
    },
    rating: 8,
    totalPoints: 1,
    lastPoints: 1
  },
  {
    id: '633fb1e0746a9884af2fbe3f',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8859',
    teamId: '453',
    name: 'Mohammed Rafique',
    shortName: 'Mohammed Rafique',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe40',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '8898',
    teamId: '2029',
    name: 'Tiri',
    shortName: 'Tiri',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe5d',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '97741',
    teamId: '2029',
    name: 'Kiyan Nassiri',
    shortName: 'Kiyan Nassiri',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe5e',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '97742',
    teamId: '2029',
    name: 'Abhishek Suryavanshi',
    shortName: 'Abhishek Suryavanshi',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe41',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '9811',
    teamId: '453',
    name: 'Nasser El Khayati',
    shortName: 'Nasser El Khayati',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '633fb1e0746a9884af2fbe68',
    matchId: '633ec64c746a9884af15dc05',
    playerId: '99914',
    teamId: '2029',
    name: 'Ravi Bahadur Rana',
    shortName: 'Ravi Bahadur Rana',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: true,
    shirtnumber: '13',
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  }
];
export const jfcVsMcfMyPlayerList = [
  {
    id: '63cb036d6bc8d3ddb965ee89',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '100346',
    teamId: '458',
    name: 'Sanjeev Stalin',
    shortName: 'Sanjeev Stalin',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee8a',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '100360',
    teamId: '460',
    name: 'PC Laldinpuia',
    shortName: 'PC Laldinpuia',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee8b',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '100361',
    teamId: '460',
    name: 'Seiminlen Doungel',
    shortName: 'Seiminlen Doungel',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee8c',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '100371',
    teamId: '458',
    name: 'Gurkirat Singh',
    shortName: 'Gurkirat Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee8d',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '103384',
    teamId: '460',
    name: 'Mohit Singh Dhami',
    shortName: 'Mohit Singh Dhami',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee8e',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '10367',
    teamId: '460',
    name: 'Rafael Crivellaro',
    shortName: 'Rafael Crivellaro',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee8f',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '112446',
    teamId: '460',
    name: 'Rakshit Dagar',
    shortName: 'Rakshit Dagar',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee90',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '112450',
    teamId: '460',
    name: 'Muhammed Uvais',
    shortName: 'Muhammed Uvais',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee91',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '135780',
    teamId: '458',
    name: 'Roy Bhaskar',
    shortName: 'Roy Bhaskar',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee92',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '202615',
    teamId: '460',
    name: 'Saphaba Singh Telem',
    shortName: 'Saphaba Singh Telem',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee93',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '202616',
    teamId: '460',
    name: 'Nikhil Barla',
    shortName: 'Nikhil Barla',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee94',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '202617',
    teamId: '460',
    name: 'Phijam Vikash Singh',
    shortName: 'Phijam Vikash Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee95',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '21026',
    teamId: '460',
    name: 'Daniel Chima Chukwu',
    shortName: 'Daniel Chima Chukwu',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee96',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '224902',
    teamId: '460',
    name: 'Ayush Jena',
    shortName: 'Ayush Jena',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee97',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '224906',
    teamId: '458',
    name: 'Ahan Prakash',
    shortName: 'Ahan Prakash',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee98',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '226211',
    teamId: '460',
    name: 'Saphaba Singh Telem',
    shortName: 'Saphaba Singh Telem',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee99',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '226662',
    teamId: '458',
    name: 'Nongtdu Halen',
    shortName: 'Nongtdu Halen',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee9a',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '22820',
    teamId: '460',
    name: 'Peter Hartley',
    shortName: 'Peter Hartley',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee9b',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '22869',
    teamId: '458',
    name: 'Greg Stewart',
    shortName: 'Greg Stewart',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee9c',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '25206',
    teamId: '458',
    name: 'Alberto Noguera',
    shortName: 'Alberto Noguera',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee9d',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '28137',
    teamId: '460',
    name: 'Ricky Lallawmawma',
    shortName: 'Ricky Lallawmawma',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee9e',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '28172',
    teamId: '460',
    name: 'Eli Sabia',
    shortName: 'Eli Sabia',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965ee9f',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '28188',
    teamId: '458',
    name: 'Mohammad Nawaz',
    shortName: 'Mohammad Nawaz',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea0',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '28203',
    teamId: '458',
    name: 'Vignesh Dakshinamurthy',
    shortName: 'Vignesh Dakshinamurthy',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea1',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '28216',
    teamId: '458',
    name: 'Lallianzuala Chhangte',
    shortName: 'Lallianzuala Chhangte',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea2',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '28316',
    teamId: '458',
    name: 'Rostyn Griffiths',
    shortName: 'Rostyn Griffiths',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea3',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '30881',
    teamId: '460',
    name: 'Jay Emmanuel Thomas',
    shortName: 'Jay Emmanuel Thomas',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea4',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '47077',
    teamId: '460',
    name: 'Harrison Sawyer',
    shortName: 'Harrison Sawyer',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea5',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '47161',
    teamId: '460',
    name: 'Jitendra Singh',
    shortName: 'Jitendra Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea6',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '47174',
    teamId: '458',
    name: 'Lalengmawia',
    shortName: 'Lalengmawia',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea7',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '47540',
    teamId: '458',
    name: 'Mohammed Asif',
    shortName: 'Mohammed Asif',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea8',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '48419',
    teamId: '460',
    name: 'Sandip Mandi',
    shortName: 'Sandip Mandi',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eea9',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '6025',
    teamId: '460',
    name: 'Dylan Fox',
    shortName: 'Dylan Fox',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeac',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '64064',
    teamId: '458',
    name: 'Mehtab Singh',
    shortName: 'Mehtab Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eead',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '64066',
    teamId: '458',
    name: 'Ayush Chhikara',
    shortName: 'Ayush Chhikara',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeae',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '64088',
    teamId: '460',
    name: 'Sheikh Sahil',
    shortName: 'Sheikh Sahil',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeaf',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '65298',
    teamId: '460',
    name: 'Ritwik Kumar Das',
    shortName: 'Ritwik Kumar Das',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb0',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '65300',
    teamId: '460',
    name: 'Boris Thangjam',
    shortName: 'Boris Thangjam',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb1',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '65327',
    teamId: '460',
    name: 'Ishan Pandita',
    shortName: 'Ishan Pandita',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb2',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '65348',
    teamId: '460',
    name: 'Vishal Yadav',
    shortName: 'Vishal Yadav',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb3',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '65354',
    teamId: '460',
    name: 'Bhupender Singh',
    shortName: 'Bhupender Singh',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb4',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '65364',
    teamId: '458',
    name: 'Phurba Tempa Lachenpa',
    shortName: 'Phurba Tempa Lachenpa',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb5',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '65365',
    teamId: '458',
    name: 'Vikram Pratap Singh',
    shortName: 'Vikram Pratap Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb6',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '6968',
    teamId: '458',
    name: 'Jorge Pereyra Diaz',
    shortName: 'Jorge Pereyra Diaz',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb7',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8653',
    teamId: '458',
    name: 'Rahul Bheke',
    shortName: 'Rahul Bheke',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb8',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8656',
    teamId: '458',
    name: 'Gursimrat Singh',
    shortName: 'Gursimrat Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeb9',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8698',
    teamId: '458',
    name: 'Th Bipin Singh',
    shortName: 'Th Bipin Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eeba',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8699',
    teamId: '460',
    name: 'Komal Thatal',
    shortName: 'Komal Thatal',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eebb',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8723',
    teamId: '460',
    name: 'Germanpreet Singh',
    shortName: 'Germanpreet Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eebc',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8728',
    teamId: '460',
    name: 'Renthlei Laldinliana',
    shortName: 'Renthlei Laldinliana',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eebd',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8744',
    teamId: '458',
    name: 'Rai Vinit',
    shortName: 'Rai Vinit',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eebe',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8767',
    teamId: '458',
    name: 'Mandar Rao Desai',
    shortName: 'Mandar Rao Desai',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eebf',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8768',
    teamId: '460',
    name: 'Pronay Halder',
    shortName: 'Pronay Halder',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec0',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8769',
    teamId: '458',
    name: 'Mourtada Fall',
    shortName: 'Mourtada Fall',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec1',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8770',
    teamId: '458',
    name: 'Ahmed Jahouh',
    shortName: 'Ahmed Jahouh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec2',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8774',
    teamId: '458',
    name: 'Amey Ganesh Ranawade',
    shortName: 'Amey Ganesh Ranawade',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec3',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8827',
    teamId: '458',
    name: 'Jackichand Singh',
    shortName: 'Jackichand Singh',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec4',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8882',
    teamId: '460',
    name: 'TP Rehenesh',
    shortName: 'TP Rehenesh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec5',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8888',
    teamId: '458',
    name: 'Rowllin Borges',
    shortName: 'Rowllin Borges',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec6',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8918',
    teamId: '460',
    name: 'Pratik Chowdhary',
    shortName: 'Pratik Chowdhary',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cb036d6bc8d3ddb965eec7',
    matchId: '63cb03286bc8d3ddb965e21b',
    playerId: '8919',
    teamId: '460',
    name: 'Farukh Choudhary',
    shortName: 'Farukh Choudhary',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  }
];
export const kerVsNorPlayerList = [
  {
    id: '63d29b536bc8d3ddb9784136',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '100344',
    teamId: '457',
    name: 'Sachin Suresh',
    shortName: 'Sachin Suresh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784137',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '100345',
    teamId: '457',
    name: 'Ruivah Hormipam',
    shortName: 'Ruivah Hormipam',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784138',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '100347',
    teamId: '457',
    name: 'Bijoy V',
    shortName: 'Bijoy V',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784139',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '100351',
    teamId: '459',
    name: 'Hira Mondal',
    shortName: 'Hira Mondal',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978413a',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '100363',
    teamId: '459',
    name: 'Justin George',
    shortName: 'Justin George',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978413b',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '100365',
    teamId: '459',
    name: 'Pragyan Medhi',
    shortName: 'Pragyan Medhi',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978413c',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '100440',
    teamId: '459',
    name: 'Manvir Singh-I',
    shortName: 'Manvir Singh-I',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978413d',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '103387',
    teamId: '457',
    name: 'Muheet Shabir',
    shortName: 'Muheet Shabir',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978413e',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '112449',
    teamId: '459',
    name: 'Alex Saji',
    shortName: 'Alex Saji',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978413f',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '112457',
    teamId: '459',
    name: 'Emil Benny',
    shortName: 'Emil Benny',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784140',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '112622',
    teamId: '459',
    name: 'Jithin Madathil Subran',
    shortName: 'Jithin Madathil Subran',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784141',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '135855',
    teamId: '457',
    name: 'Bryce Miranda',
    shortName: 'Bryce Miranda',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784142',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '16445',
    teamId: '459',
    name: 'Romain Philippoteaux',
    shortName: 'Romain Philippoteaux',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784143',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '17023',
    teamId: '457',
    name: 'Dimitris Diamantakos',
    shortName: 'Dimitris Diamantakos',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784144',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '197052',
    teamId: '457',
    name: 'Vibin Mohanan',
    shortName: 'Vibin Mohanan',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784145',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '197054',
    teamId: '459',
    name: 'Aaron Michael Evans',
    shortName: 'Aaron Michael Evans',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784146',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202603',
    teamId: '457',
    name: 'Saurav Mondal',
    shortName: 'Saurav Mondal',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784147',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202604',
    teamId: '457',
    name: 'Nihal Sudeesh',
    shortName: 'Nihal Sudeesh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784148',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202605',
    teamId: '457',
    name: 'Sreekuttan M S',
    shortName: 'Sreekuttan M S',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 4,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784149',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202606',
    teamId: '457',
    name: 'Mohammed Aimen',
    shortName: 'Mohammed Aimen',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978414a',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202607',
    teamId: '457',
    name: 'Mohammed Azhar',
    shortName: 'Mohammed Azhar',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978414b',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202608',
    teamId: '457',
    name: 'Roshan Gigi',
    shortName: 'Roshan Gigi',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978414c',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202620',
    teamId: '459',
    name: 'Khoirom Singh',
    shortName: 'Khoirom Singh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978414d',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202621',
    teamId: '459',
    name: 'Parthib Gogoi',
    shortName: 'Parthib Gogoi',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978414e',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '202633',
    teamId: '459',
    name: 'Jon Gaztanada Arrospide',
    shortName: 'Jon Gaztanada Arrospide',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978414f',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '227464',
    teamId: '457',
    name: 'Tejas Krishna',
    shortName: 'Tejas Krishna',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784150',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '23727',
    teamId: '459',
    name: 'Kule Mbombo',
    shortName: 'Kule Mbombo',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784151',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '24869',
    teamId: '457',
    name: 'Apostolos Giannou',
    shortName: 'Apostolos Giannou',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784152',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '28152',
    teamId: '457',
    name: 'Sandeep Singh',
    shortName: 'Sandeep Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784153',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '28174',
    teamId: '459',
    name: 'Tondonba Singh',
    shortName: 'Tondonba Singh',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784154',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '4174',
    teamId: '457',
    name: 'Marko Leskovic',
    shortName: 'Marko Leskovic',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784155',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '44386',
    teamId: '457',
    name: 'Victor Mongil Adeva',
    shortName: 'Victor Mongil Adeva',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784156',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47145',
    teamId: '457',
    name: 'Prabhsukhan Singh',
    shortName: 'Prabhsukhan Singh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784157',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47172',
    teamId: '459',
    name: 'Gaurav Bora',
    shortName: 'Gaurav Bora',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784158',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47176',
    teamId: '459',
    name: 'Alfred Lalruotsang',
    shortName: 'Alfred Lalruotsang',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784159',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47179',
    teamId: '457',
    name: 'Jeakson Singh',
    shortName: 'Jeakson Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978415a',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47180',
    teamId: '457',
    name: 'Rahul KP',
    shortName: 'Rahul KP',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978415b',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47187',
    teamId: '457',
    name: 'Jessel Carneiro',
    shortName: 'Jessel Carneiro',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978415c',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47196',
    teamId: '459',
    name: 'Laldanmawia Ralte',
    shortName: 'Laldanmawia Ralte',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978415f',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '47277',
    teamId: '459',
    name: 'Pragyan Gogoi',
    shortName: 'Pragyan Gogoi',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784160',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '48694',
    teamId: '459',
    name: 'Dipu Mirdha',
    shortName: 'Dipu Mirdha',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784161',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '5876',
    teamId: '459',
    name: 'Michael Jakobsen',
    shortName: 'Michael Jakobsen',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784162',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64023',
    teamId: '459',
    name: 'Joe Zoherliana',
    shortName: 'Joe Zoherliana',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784163',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64030',
    teamId: '459',
    name: 'Emanuel Lalchhanchhuaha',
    shortName: 'Emanuel Lalchhanchhuaha',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784164',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64031',
    teamId: '459',
    name: 'Gurjinder Kumar',
    shortName: 'Gurjinder Kumar',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784165',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64032',
    teamId: '459',
    name: 'Rochharzela',
    shortName: 'Rochharzela',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784166',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64035',
    teamId: '459',
    name: 'Mashoor Thangalakath',
    shortName: 'Mashoor Thangalakath',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784167',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64036',
    teamId: '459',
    name: 'Nikhil Deka',
    shortName: 'Nikhil Deka',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784168',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64038',
    teamId: '457',
    name: 'Givson Singh',
    shortName: 'Givson Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784169',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64070',
    teamId: '459',
    name: 'Joseba Beitia',
    shortName: 'Joseba Beitia',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978416a',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64095',
    teamId: '459',
    name: 'Mirshad Michu',
    shortName: 'Mirshad Michu',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978416b',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '64100',
    teamId: '459',
    name: 'Mohammed Irshad',
    shortName: 'Mohammed Irshad',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978416c',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '65297',
    teamId: '457',
    name: 'Ayush Adhikari',
    shortName: 'Ayush Adhikari',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978416d',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '65362',
    teamId: '459',
    name: 'Nabin Rabha',
    shortName: 'Nabin Rabha',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978416e',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '65363',
    teamId: '459',
    name: 'Imran Khan',
    shortName: 'Imran Khan',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784170',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '82894',
    teamId: '457',
    name: 'Ivan Kalyuzhny Volodymyrovych',
    shortName: 'Ivan Kalyuzhny Volodymyrovych',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784177',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8539',
    teamId: '459',
    name: 'Wilmar Jordan',
    shortName: 'Wilmar Jordan',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978417a',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8642',
    teamId: '457',
    name: 'Harmanjot Khabra',
    shortName: 'Harmanjot Khabra',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978417b',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8660',
    teamId: '457',
    name: 'Nishu Kumar',
    shortName: 'Nishu Kumar',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978417c',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8696',
    teamId: '459',
    name: 'Rupert Nongrum',
    shortName: 'Rupert Nongrum',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978417d',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8709',
    teamId: '457',
    name: 'Karanjit Singh',
    shortName: 'Karanjit Singh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978417e',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8812',
    teamId: '459',
    name: 'Gani Ahmed Nigam',
    shortName: 'Gani Ahmed Nigam',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb978417f',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8838',
    teamId: '457',
    name: 'Sahal Abdul Samad',
    shortName: 'Sahal Abdul Samad',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784180',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8856',
    teamId: '459',
    name: 'Arindam Bhattacharja',
    shortName: 'Arindam Bhattacharja',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784181',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8860',
    teamId: '459',
    name: 'Sehnaj Singh',
    shortName: 'Sehnaj Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784182',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '8896',
    teamId: '459',
    name: 'Provat Lakra',
    shortName: 'Provat Lakra',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784183',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '9175',
    teamId: '457',
    name: 'Adrian Luna',
    shortName: 'Adrian Luna',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63d29b536bc8d3ddb9784184',
    matchId: '63d29ad46bc8d3ddb9782e01',
    playerId: '97177',
    teamId: '457',
    name: 'Bidyashagar Singh',
    shortName: 'Bidyashagar Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6,
    totalPoints: 0
  }
];
export const atkVsOdiPlayerList = [
  {
    id: '63cda5006bc8d3ddb9c928bc',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '100355',
    teamId: '2029',
    name: 'Lalrinliana Hnamte',
    shortName: 'Lalrinliana Hnamte',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928bd',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '100416',
    teamId: '454',
    name: 'Sebastian Thangmuansang',
    shortName: 'Sebastian Thangmuansang',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928be',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '100417',
    teamId: '454',
    name: 'Deven Sawhney',
    shortName: 'Deven Sawhney',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928bf',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '103383',
    teamId: '454',
    name: 'Akshunna Tyagi',
    shortName: 'Akshunna Tyagi',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928c3',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '109511',
    teamId: '2029',
    name: 'Sumit Rathi',
    shortName: 'Sumit Rathi',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928c9',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '115916',
    teamId: '2029',
    name: 'Ricky John Shabong',
    shortName: 'Ricky John Shabong',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928cd',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '12049',
    teamId: '454',
    name: 'Victor Rodriguez',
    shortName: 'Victor Rodriguez',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928d4',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '14021',
    teamId: '2029',
    name: 'Joni Kauko',
    shortName: 'Joni Kauko',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928da',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '197697',
    teamId: '2029',
    name: 'Debnath Mondal',
    shortName: 'Debnath Mondal',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928e0',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '202627',
    teamId: '454',
    name: 'Rishabh Dobriyal',
    shortName: 'Rishabh Dobriyal',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928e8',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '202985',
    teamId: '454',
    name: 'Carlos Javier',
    shortName: 'Carlos Javier',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928e9',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '22826',
    teamId: '2029',
    name: 'Carl McHugh',
    shortName: 'Carl McHugh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928f5',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '25713',
    teamId: '454',
    name: 'Pedro Martin',
    shortName: 'Pedro Martin',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928f6',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '28154',
    teamId: '2029',
    name: 'Avilash Paul',
    shortName: 'Avilash Paul',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928fc',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '28190',
    teamId: '2029',
    name: 'Federico Gallego',
    shortName: 'Federico Gallego',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928fd',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '28196',
    teamId: '2029',
    name: 'Lalthathanga Khawlhring',
    shortName: 'Lalthathanga Khawlhring',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928fe',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '28202',
    teamId: '454',
    name: 'Raynier Fernandes',
    shortName: 'Raynier Fernandes',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c928ff',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '28210',
    teamId: '454',
    name: 'Karan Amin',
    shortName: 'Karan Amin',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92900',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '28267',
    teamId: '454',
    name: 'Michael Soosairaj',
    shortName: 'Michael Soosairaj',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9290a',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '29963',
    teamId: '454',
    name: 'Hendry Antonay',
    shortName: 'Hendry Antonay',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92912',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '31993',
    teamId: '2029',
    name: 'Florentin Pogba',
    shortName: 'Florentin Pogba',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92922',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '399',
    teamId: '2029',
    name: 'Dimitri Petratos',
    shortName: 'Dimitri Petratos',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9292e',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '40969',
    teamId: '454',
    name: 'Saul Crespo Prieto',
    shortName: 'Saul Crespo Prieto',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92939',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '44252',
    teamId: '2029',
    name: 'Slavko Damjanovic',
    shortName: 'Slavko Damjanovic',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9293a',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '47164',
    teamId: '454',
    name: 'Niraj Kumar',
    shortName: 'Niraj Kumar',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92944',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '47165',
    teamId: '454',
    name: 'Narender Gahlot',
    shortName: 'Narender Gahlot',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92945',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '47197',
    teamId: '2029',
    name: 'Asish Rai',
    shortName: 'Asish Rai',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92946',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '47257',
    teamId: '454',
    name: 'Lalhrezuala Sailung',
    shortName: 'Lalhrezuala Sailung',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92947',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '47258',
    teamId: '454',
    name: 'Van Lal Remtluanga Chhangte',
    shortName: 'Van Lal Remtluanga Chhangte',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92948',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '49182',
    teamId: '2029',
    name: 'Arsh Anwer Shaikh',
    shortName: 'Arsh Anwer Shaikh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92949',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '56679',
    teamId: '454',
    name: 'Diego Mauricio',
    shortName: 'Diego Mauricio',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92951',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '6039',
    teamId: '454',
    name: 'Osama Malik',
    shortName: 'Osama Malik',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92952',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '6066',
    teamId: '2029',
    name: 'Brendan Hamill',
    shortName: 'Brendan Hamill',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92953',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '64050',
    teamId: '454',
    name: 'Paul Ramfangzauva',
    shortName: 'Paul Ramfangzauva',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92954',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '64053',
    teamId: '454',
    name: 'Thoiba Singh Moirangthem',
    shortName: 'Thoiba Singh Moirangthem',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92955',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '64055',
    teamId: '454',
    name: 'Isak Vanlalruatfela',
    shortName: 'Isak Vanlalruatfela',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 6.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92956',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '64059',
    teamId: '454',
    name: 'Antonio D Silva',
    shortName: 'Antonio D Silva',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92957',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '65296',
    teamId: '454',
    name: 'Denechandra Meitei',
    shortName: 'Denechandra Meitei',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9295f',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '65301',
    teamId: '2029',
    name: 'Ningombam Engson Singh',
    shortName: 'Ningombam Engson Singh',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92960',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '65303',
    teamId: '2029',
    name: 'Md Fardin Ali Molla',
    shortName: 'Md Fardin Ali Molla',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92961',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '65343',
    teamId: '454',
    name: 'Nikhil Prabhu',
    shortName: 'Nikhil Prabhu',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92962',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8648',
    teamId: '454',
    name: 'Lalthuammawia Ralte',
    shortName: 'Lalthuammawia Ralte',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 4.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92963',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8663',
    teamId: '2029',
    name: 'Subashish Bose',
    shortName: 'Subashish Bose',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92964',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8722',
    teamId: '454',
    name: 'Isaac Vanmalsawma',
    shortName: 'Isaac Vanmalsawma',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92965',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8729',
    teamId: '2029',
    name: 'Deepak Tangri',
    shortName: 'Deepak Tangri',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92966',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8739',
    teamId: '2029',
    name: 'Pritam Kotal',
    shortName: 'Pritam Kotal',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92967',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8748',
    teamId: '454',
    name: 'Nandhakumar Sekar',
    shortName: 'Nandhakumar Sekar',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92968',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8752',
    teamId: '454',
    name: 'Shubham Sarangi',
    shortName: 'Shubham Sarangi',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 7,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92969',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8764',
    teamId: '2029',
    name: 'Lenny Rodrigues',
    shortName: 'Lenny Rodrigues',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92971',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8765',
    teamId: '2029',
    name: 'Hugo Boumous',
    shortName: 'Hugo Boumous',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92972',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8776',
    teamId: '2029',
    name: 'Manvir Singh',
    shortName: 'Manvir Singh',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92973',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8781',
    teamId: '2029',
    name: 'Liston Colaco',
    shortName: 'Liston Colaco',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92974',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8801',
    teamId: '2029',
    name: 'Ashique Kuruniyan',
    shortName: 'Ashique Kuruniyan',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92975',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8802',
    teamId: '2029',
    name: 'Vishal Kaith',
    shortName: 'Vishal Kaith',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92976',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8811',
    teamId: '454',
    name: 'Sahil Panwar',
    shortName: 'Sahil Panwar',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 8.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92977',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8828',
    teamId: '454',
    name: 'Lalruatthara',
    shortName: 'Lalruatthara',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 6,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92978',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8855',
    teamId: '454',
    name: 'Amrinder Singh',
    shortName: 'Amrinder Singh',
    playingEleven: false,
    role: 'Goalkeeper',
    played: false,
    substitute: false,
    playingRole: 'Goalkeeper',
    rating: 8,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9297a',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8898',
    teamId: '2029',
    name: 'Tiri',
    shortName: 'Tiri',
    playingEleven: false,
    played: false,
    substitute: false,
    rating: null,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9297e',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '8915',
    teamId: '454',
    name: 'Jerry Mawihmingthanga',
    shortName: 'Jerry Mawihmingthanga',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 9,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c92986',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '97741',
    teamId: '2029',
    name: 'Kiyan Nassiri',
    shortName: 'Kiyan Nassiri',
    playingEleven: false,
    role: 'Forward',
    played: false,
    substitute: false,
    playingRole: 'Forward',
    rating: 7.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9298a',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '97742',
    teamId: '2029',
    name: 'Abhishek Suryavanshi',
    shortName: 'Abhishek Suryavanshi',
    playingEleven: false,
    role: 'Midfielder',
    played: false,
    substitute: false,
    playingRole: 'Midfielder',
    rating: 5.5,
    totalPoints: 0
  },
  {
    id: '63cda5006bc8d3ddb9c9298b',
    matchId: '63cda4c06bc8d3ddb9c91f39',
    playerId: '99914',
    teamId: '2029',
    name: 'Ravi Bahadur Rana',
    shortName: 'Ravi Bahadur Rana',
    playingEleven: false,
    role: 'Defender',
    played: false,
    substitute: false,
    playingRole: 'Defender',
    rating: 5,
    totalPoints: 0
  }
];
